<template>
  <section>
    <!-- top-menu -->
    <top-menu/>
    <!-- detail-funnel -->
    <section>
      <modal-obs-funil :actionTxtInfo.sync="actionEmit"/>
      <modal-onboarding :getInfo="sendInfoToModal"/>
      <modal-set-active-funil :runFunction="dataInfoCompany" :responsibles="dataSelectResponsibles"/>
      <modal-password title-modal="Deletar atividade"
                      subtitle-modal="Digite a senha do admin para deletar a atividade" :run-function="removeActive"/>
      <modal-change-contact-phone-funil :objRS="sendObjRS"/>
      <modal-change-onboarding :value-current="dataCompany.clientJourney"
                               :oldStatus="dataCompany.clientJourney"
                               :userIdFunnel="dataUser.id"
                               :dataUserNameFunnel="dataUser.name"
                               :companyIdFunnel="dataCompany.id"
                               :ownerActualFunnel="ownerActual"
                               :companyContextFunnel="dataCompany.contentContext"
                               :runFunction="dataInfoCompany"/>
      <modal-default modal-title="Criar tag"
                     modal-subtitle="Preencha os campos para criar uma TAG nova"
                     modal-id="createTag" width="500px">
        <template>
          <input-text @contentText="value => newTag.name = value" col="7" is-required="true"
                      :input-error="validateModalTagName" type="text"
                      placeholder="Digite o nome de TAG"
                      label="Nome da TAG"/>
          <input-color @update:colorValue="value => newTag.color = value" col="5" is-required="true"
                       :input-error="validateModalTagColor"
                       label="Cor da TAG"/>
          <btn-search @emit-click="createTag" which-side="right" label="Criar" :have-loading="true"
                      :loading="loadingBtnTag"/>
        </template>
      </modal-default>
      <modal-default modal-title="Nova pesquisa de CSAT" modal-id="linkCSAT" width="689px">
        <template class="search">
          <input-select col="6" :options="statusOnboardingSelect" label="Etapa"
                        @selectedOption="value => statusOnboardingSelected = value" is-required="true"
                        :input-error="validateStatusOnboardingSelected"/>
          <input-select col="6" :options="dataSelectResponsiblesCsat" nameOnlyString="true"
                        label="Responsável"
                        @selectedOptionString="value => selectedResponsibleCsat = value" is-required="true"
                        :input-error="validateResponsibleSelected"/>
          <div class="col-md-12 search__required">
            O cliente precisará estar logado no Painel Administrativo para responder à pesquisa.
          </div>
          <div class="col-md-12 search__generate">
            <span v-if="linkGeneratedCSAT" class="search__btn">
              <span v-if="!loadingLinkCSAT" @click="generateLinkCSAT()">
                <ion-icon name="link-outline"></ion-icon>
                Gerar link de CSAT
              </span>
              <span v-else>
                <div class="loading-btn button-loading">
                  <div class="spinner-btn button-spinner">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5"></div>
                  </div>
                </div>
              </span>
            </span>
            <div v-else class="search__generated">
              <span class="search__generated__btn">
                <ion-icon name="checkmark-circle-outline"></ion-icon>
                Link gerado!
              </span>
              <span class="search__generated__link">{{ linkCSAT }}</span>
              <span class="search__generated__copy"
                    @click="copyLink(linkCSAT)">
                <ion-icon name="link-outline"></ion-icon>
                Copiar link&nbsp;
              </span>
              <span v-if="copied" class="search__generated__copied">Link copiado!</span>
            </div>
            <span v-if="!linkGeneratedCSAT" class="search__btn">
              <span @click="openModalSendEmailCsat()">
                <ion-icon name="mail-outline"></ion-icon>
                Enviar e-mail
              </span>
            </span>
          </div>
        </template>
      </modal-default>
      <modal-default modal-title="Nova pesquisa de NPS" modal-id="linkNPS" width="800px">
        <template class="search">
          <input-select col="6" :options="dataSelectResponsiblesNps" nameOnlyString="true"
                        label="Responsável"
                        @selectedOptionString="value => selectedResponsibleNps = value" is-required="true"
                        :input-error="validateResponsibleSelected"/>
          <div class="col-md-12 search__required">
            O cliente precisará estar logado no Painel Administrativo para responder à pesquisa.
          </div>
          <div class="col-md-12 search__generate">
            <span v-if="linkGeneratedNPS" class="search__btn">
              <span v-if="!loadingLinkNPS" @click="generateLinkNPS()">
                <ion-icon name="link-outline"></ion-icon>
                Gerar link de NPS
              </span>
              <span v-else>
                <div class="loading-btn button-loading">
                  <div class="spinner-btn button-spinner">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5"></div>
                  </div>
                </div>
              </span>
            </span>
            <div v-else class="search__generated">
              <span class="search__generated__btn">
                <ion-icon name="checkmark-circle-outline"></ion-icon>
                Link gerado!
              </span>
              <span class="search__generated__link">{{ linkNPS }}</span>
              <span class="search__generated__copy"
                    @click="copyLink(linkNPS)">
                <ion-icon name="link-outline"></ion-icon>
                Copiar link&nbsp;
              </span>
              <span v-if="copied" class="search__generated__copied">Link copiado!</span>
            </div>
            <span v-if="!linkGeneratedNPS" class="search__btn">
              <span @click="sendEmailNps()">
                <ion-icon name="mail-outline"></ion-icon>
                Enviar e-mail
              </span>
            </span>
          </div>
        </template>
      </modal-default>
      <modal-default modal-title="Alterar status da atividade" modal-id="statusActivities" width="400px">
        <template>
          <input-select @selectedOptionNumber="value => selectedNewStatusActivities = value" valueIsNumber="true"
                        col="12" :options="statusActivities" label="Status" is-required="true"
                        :input-error="validateStatusActivities"/>
          <btn-search @emit-click="sendChangeStatusActivie" label="Enviar" whichSide="right"
                      have-loading="true"
                      :loading="loadingSendStatusActivities"/>
        </template>
      </modal-default>
      <modal-default modal-title="Enviar email CSAT" modal-id="email-csat" marginTop="430px">
        <template>
          <div class="csat-email">
            <vue-tags-input
              v-model="emailToSend"
              :tags="emails"
              @tags-changed="newTags => emails = newTags"
              placeholder="Add e-mail"
            />
            <btn-search @emit-click="sendEmailCsat()" label="Enviar" whichSide="right" have-loading="true"
                        :loading="loadingSendingEmail" :disabled="!emails.length"/>
          </div>
        </template>
      </modal-default>
      <modal-open-ticket :dataCompanyModal="dataCompanyModal"/>

      <div class="page-content all-tags">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->

            <!-- Table -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <full-loading v-if="loadingList"/>

              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-4">
                <div class="col-md-12 default-box attendance">
                  <div class="col-md-6 attendance__csat">
                    <h3 class="attendance__title">
                      CSAT
                      <router-link to="/relatorio-csat" target="_blank">
                        <ion-icon name="open-outline"></ion-icon>
                      </router-link>
                    </h3>
                    <div class="attendance__body">
                      <img v-if="dataLastCSAT.experienceScore === 1" style="background: #FF445D"
                           src="../../../../assets/img/emote/bravo.png"
                           alt="img">
                      <img v-else-if="dataLastCSAT.experienceScore === 2" style="background: #FF445D"
                           src="../../../../assets/img/emote/triste.png"
                           alt="img">
                      <img v-else-if="dataLastCSAT.experienceScore === 3" style="background: #FF9900"
                           src="../../../../assets/img/emote/neutro.png"
                           alt="img">
                      <img v-else-if="dataLastCSAT.experienceScore === 4" style="background: #2ACC6B"
                           src="../../../../assets/img/emote/feliz.png"
                           alt="img">
                      <img v-else-if="dataLastCSAT.experienceScore === 5" style="background: #2ACC6B"
                           src="../../../../assets/img/emote/feliz-coracao.png" alt="img">
                      <img v-else style="background: #D5DFEB"
                           src="../../../../assets/img/emote/neutro-empty.png" alt="img">
                      <div class="attendance__content">
                        <span v-if="dataLastCSAT.experienceScore === 1" class="attendance__status">Muito ruim</span>
                        <span v-else-if="dataLastCSAT.experienceScore === 2" class="attendance__status">Ruim</span>
                        <span v-else-if="dataLastCSAT.experienceScore === 3" class="attendance__status">Médio</span>
                        <span v-else-if="dataLastCSAT.experienceScore === 4" class="attendance__status">Bom</span>
                        <span v-else-if="dataLastCSAT.experienceScore === 5" class="attendance__status">Excelente</span>
                        <span v-else class="attendance__status">-</span>
                        <span>Respondido em</span>
                        <span>{{ dataLastCSAT.responseDate | formatDate }}</span>
                      </div>
                    </div>
                    <span class="attendance__link" data-toggle="modal" data-target="#linkCSAT">
                      <ion-icon name="link-outline"></ion-icon> Gerar link CSAT&nbsp;
                    </span>
                  </div>
                  <div class="col-md-6 attendance__nps">
                    <h3 class="attendance__title">
                      NPS
                      <router-link to="/novo-nps" target="_blank">
                        <ion-icon name="open-outline"></ion-icon>
                      </router-link>
                    </h3>
                    <div class="attendance__body">
                      <span v-if="[9, 10].includes(lastNpsResult.rating)" style="background: #2ACC6B"
                            class="attendance__note">{{ lastNpsResult.rating }}</span>
                      <span v-else-if="[7, 8].includes(lastNpsResult.rating)" style="background: #FF9900"
                            class="attendance__note">{{ lastNpsResult.rating }}</span>
                      <span
                        v-else-if="[0, 1, 2, 3, 4, 5, 6].includes(lastNpsResult.rating) && lastNpsResult.responseDate"
                        style="background: #FF445D"
                        class="attendance__note">{{ lastNpsResult.rating }}</span>
                      <span v-else class="attendance__note" style="background: #D5DFEB; color: #7F8897">-</span>
                      <div class="attendance__content">
                        <span class="attendance__status"
                              v-if="[9, 10].includes(lastNpsResult.rating)">Promotor</span>
                        <span class="attendance__status"
                              v-else-if="[7, 8].includes(lastNpsResult.rating)">Neutro</span>
                        <span class="attendance__status"
                              v-else-if="[0, 1, 2, 3, 4, 5, 6].includes(lastNpsResult.rating) && lastNpsResult.responseDate">Detrator</span>
                        <span class="attendance__status" v-else> - </span>
                        <span v-if="lastNpsResult.responseDate">Respondido em</span>
                        <span v-if="lastNpsResult.responseDate">{{ lastNpsResult.responseDate | formatDate }}</span>
                        <span v-else-if="lastNpsResult.id && !lastNpsResult.responseDate">Resposta pendente</span>
                      </div>
                    </div>
                    <span
                      v-if="lastNpsGenerated.responseDate || (!lastNpsGenerated.responseDate && !lastNpsGenerated.id)"
                      class="attendance__link" data-toggle="modal" data-target="#linkNPS">
                      <ion-icon name="link-outline"></ion-icon> Gerar link NPS&nbsp;
                    </span>
                    <span v-if="!lastNpsGenerated.responseDate && lastNpsGenerated.id" class="attendance__link"
                          @click="copyLinkNps(lastNpsGenerated.link)">
                      <ion-icon name="link-outline"></ion-icon> Copiar link do último NPS gerado&nbsp;
                    </span>
                    <tooltip-default :show-tooltip="copiedNps" width="50px" height="25px"
                                     hasPersonalizedStyledMinimal="true" title="Link copiado!"></tooltip-default>

                    <span v-if="!lastNpsGenerated.responseDate && lastNpsGenerated.id" class="attendance__link"
                          @click="sendEmailNps()">
                      <ion-icon name="link-outline"></ion-icon> Enviar email&nbsp;
                    </span>
                  </div>
                </div>

                <div v-if="dataTickets.items.length" class="col-xs-12 col-sm-12 col-md-12 default-box box-tickets">
                  <h5>Tickets #{{ dataTickets.items.length }}</h5>
                  <button class="btn-new-ticket" @click="openTicket()">Novo ticket</button>
                  <ul>
                    <li v-for="(ticket, index) in dataTickets.items"
                        :key="index" :class="{isLate: ticket.isLate}"
                        v-if="!(ticket.stageName.includes('Concluído') || ticket.stageName.includes('Arquivado'))">
                      <a :href="'/lista-de-ticket/' + ticket.ticketId" target="_blank"
                         :title="ticket.title">{{ ticket.createdAtStr }} -
                        #{{ ticket.ticketId }} Ticket: {{ ticket.title }}</a>
                      <p :title="ticket.responsiblesName"><span>Responsável:</span> {{ ticket.responsiblesName }}</p>
                      <p><span>Status:</span> {{ ticket.stageName }}</p>
                      <p><span>Dono:</span> {{ ticket.whoCreatedName }}</p>
                    </li>
                    <li v-for="(ticket, index) in dataTickets.items"
                        :key="index" class="done"
                        v-if="(ticket.stageName.includes('Concluído') || ticket.stageName.includes('Arquivado'))">
                      <a :href="'/lista-de-ticket/' + ticket.ticketId" target="_blank"
                         :title="ticket.title">{{ ticket.createdAtStr }} -
                        #{{ ticket.ticketId }} Ticket: {{ ticket.title }}</a>
                      <p :title="ticket.responsiblesName"><span>Responsável:</span> {{ ticket.responsiblesName }}</p>
                      <p><span>Status:</span> {{ ticket.stageName }}</p>
                      <p><span>Dono:</span> {{ ticket.whoCreatedName }}</p>
                    </li>
                  </ul>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 default-box box-buttons">
                  <div>
                    <a :href="'/detalhes-da-empresa/' + dataCompany.id + '/' + dataCompany.contentContext"
                       target="_blank">Detalhes da empresa</a>
                    <a :href="'/lista-turnos/' + dataCompany.id + '/' + dataCompany.contentContext" target="_blank">Visualizar
                      turnos</a>
                    <a :href="'/lista-turnos-ciclico/' + dataCompany.id + '/' + dataCompany.contentContext"
                       target="_blank">Visualizar turnos cíclicos</a>
                    <a :href="'/avisos-da-empresa/' + dataCompany.id + '/' + dataCompany.contentContext"
                       target="_blank">Enviar e visualizar avisos</a>
                  </div>
                  <div>
                    <a :href="'/lista-de-assinaturas/' + dataCompany.id" target="_blank">Ver assinatura</a>
                    <a :href="'/lista-unidades-negocio/' + dataCompany.id + '/' + dataCompany.contentContext"
                       target="_blank">Ver unidade de negócio</a>
                    <a :href="'/historico-de-faturas/' + dataCompany.id" target="_blank">Histórico de faturas</a>
                  </div>
                </div>

                <div class="col-md-12 default-box box-company-detail-f">
                  <!-- <p v-if="dataNps.npsText" v-bind:style="{'background': dataNps.npsColor}" class="nps-text-info"
                     data-toggle="tooltip" v-bind:title="dataNps.npsTextFull">{{ dataNps.npsText }}</p> -->
                  <h5>Detalhes da Empresa
                    <span><a v-if="dataCompany.id && dataCompany.contentContext"
                             v-bind:href="'/detalhe-health-score/' + dataCompany.id + '/' + dataCompany.contentContext"
                             target="_blank" class="link">Ver HealthScore</a></span>
                  </h5>

                  <div class="box-tag">
                    <span v-for="(t, index) in dataTag" class="tag" v-bind:style="{'background': t.color}">{{ t.value }} <i
                      v-on:click="deleteCompanyTag(index, t)" class="fa fa-times" aria-hidden="true"></i></span>
                  </div>

                  <p>Empresa:
                    <span>
                      <a v-bind:href="'/detalhes-da-empresa/' + dataCompany.id + '/' + dataCompany.contentContext"
                         v-bind:title="dataCompany.name" target="_blank"
                         class="link">{{ dataCompany.name | limitTo(30) }}</a>
                    </span>
                  </p>
                  <p>Email: <span>{{ dataCompany.email }}</span></p>
                  <p>ID: <span>{{ dataCompany.id }}</span></p>
                  <p>Nome do Contato:
                    <span v-if="dataContacts.contactName">
                      <a v-on:click="changePhone()">
                        {{ dataContacts.contactName }}
                      </a>
                    </span>
                    <span v-if="!dataContacts.contactName">
                      <a v-on:click="changePhone()">Adicionar</a>
                    </span>
                  </p>
                  <p>E-mail do Contato:
                    <span v-if="dataContacts.contactEmail">
                      <a v-on:click="changePhone()">{{ dataContacts.contactEmail }}</a>
                    </span>
                    <span v-if="!dataContacts.contactEmail"><a v-on:click="changePhone()">Adicionar</a></span>
                  </p>
                  <p>Contato:
                    <span v-if="dataContacts.primaryTelephone || dataContacts.secundaryTelephone">
                      <a v-on:click="changePhone()">
                        {{ dataContacts.primaryTelephone }} - {{ dataContacts.secundaryTelephone }}
                      </a>
                    </span>
                    <span v-if="!dataContacts.primaryTelephone && !dataContacts.secundaryTelephone">
                      <a v-on:click="changePhone()">Adicionar</a>
                    </span>
                  </p>
                  <p>Data de cadastro: <span>{{ dataCompany.createdAt }}</span></p>
                  <p>Plano: <span>{{ dataCompany.planName }}</span></p>
                  <p>Expira em: <span>{{ salesObj.expireIn | formatDate }}</span></p>
                  <p>LT atual: <span>{{ dataCompany.lt }}</span></p>
                  <p>MRR Inicial: <span>{{ dataFinancial.initialMRR }}</span></p>
                  <p>MRR Atual: <span>{{ dataFinancial.currentMRR }}</span></p>
                  <p v-if="false">LT: <span>{{ dataFinancial.currentMRR }}</span></p>
                  <btn-excel @emit-event-excel="downloadExcel()" position="true"/>

                  <h5>Último Pagamento</h5>
                  <p>Data: <span>{{ dataPayment.lastPaid }}</span></p>
                  <p>Total Pago: <span>{{ dataPayment.totalPaid }}</span></p>
                </div>
                <!-- <div v-if="saleInfo" class="col-xs-12 col-sm-12 col-md-12 default-box box-company-infos">
                  <h5>Objetivos da Empresa</h5>
                  <div class="company-goals">
                    <span>Data da venda:
                      <b>{{ saleInfo.createdAt | formatFullDate }}</b>
                    </span>
                    <span class="goals-content">
                      <span v-if="saleInfo.usingSchedule">Usando escalas: <b>Sim</b></span>
                      <span v-else>Usando escalas: <b>Não</b></span>
                    </span>
                    <span v-if="saleInfo.customSpecification" class="goals-content">
                      <span>Especificação personalizada: </span>
                      <b>{{ saleInfo.specification }}</b>
                    </span>
                    <div class="goals-content">
                      <span class="content-group">
                        Dores:
                        <span style="margin-top: 5px;" v-for="(value, index) in saleInfo.dores" :key="index">
                          <b>- {{ value }}</b>
                        </span>
                      </span>
                      <span v-if="saleInfo.otherDor">
                        <b>{{ saleInfo.otherDor }}</b>
                      </span>
                    </div>
                    <div class="goals-content">
                      <span class="content-group">
                        Objetivos:
                        <span style="margin-top: 5px;" v-for="(value, index) in saleInfo.objetivos" :key="index">
                          <b>- {{ value }}</b>
                        </span>
                      </span>
                      <span v-if="saleInfo.otherObjetivo">
                        <b>{{ saleInfo.otherObjetivo }}</b>
                      </span>
                    </div>
                    <div class="goals-content" style="border-bottom: none;">
                      <span class="content-group">
                        Recursos adicionais:
                        <span style="margin-top: 5px;" v-for="(value, index) in saleInfo.features" :key="index">
                          <b>- {{ value }}</b>
                        </span>
                      </span>
                    </div>
                  </div>
                </div> -->
                <div class="col-xs-12 col-sm-12 col-md-12 default-box box-company-infos">
                  <h5>Infos Importantes</h5>

                  <textarea id="important-infos" v-model="dataNotes" placeholder="Escreva..." disabled></textarea>
                  <button id="change-edit-info" class="btn-edit-info" @click="editText();">
                    <span>Editar</span>
                  </button>
                  <button hidden id="change-info-save" @click="saveAlert();" :disabled="loadingOwner"
                          v-bind:class="{'disable': loadingOwner}" class="btn-save-info" type="submit">
                    <span v-if="!loadingActive">Salvar</span>
                    <div class="loading-btn" v-else>
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </button>
                  <button hidden id="change-info-cancel" class="btn-edit-cancel" @click="cancelAlert()">
                    <span>Cancelar</span>
                  </button>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 default-box box-owner">
                  <h5>Responsável atual: <span>{{ ownerActualFormated }}</span></h5>
                  <label>Alterar responsável</label>
                  <input-multi-select-own @selectedString="value => owner = value" col="12"
                                          :list-items="dataSelectResponsiblesFormated" :is-name="true"/>
                  <button v-on:click="setOwner()" :disabled="loadingOwner" v-bind:class="{'disable': loadingOwner}"
                          class="btn-send-owner" type="submit">
                    <span v-if="!loadingOwner">Salvar</span>
                    <div class="loading-btn" v-else>
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </button>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 default-box box-metrics">
                  <h5>Métricas da Empresa</h5>

                  <p>Total de admin: <span>{{ companyMetrics.totalAdmins }}</span></p>
                  <p>Último acesso do admin: <span>{{ companyMetrics.lastLoginAdmin }}</span></p>
                  <p>Total de funcionários: <span>{{ companyMetrics.totalEmployee }}</span></p>
                  <p>Faltas ultimo dia da base ativa: <span>{{ companyMetrics.totalFaultYesterday }}</span></p>
                  <p>Pontos ultimo dia base ativa: <span>{{ companyMetrics.totalPointsYesterday }}</span></p>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 default-box box-activities">
                  <h5>Atividades Agendadas</h5>
                  <div class="active" v-for="(value, index) in activities" :key="index">
                    <div class="active-header">
                      <div class="header-title">
                        <span class="title" v-tooltip.top-center="value.businessTaskTypeStr">
                          #{{ index + 1 }} {{ value.businessTaskTypeStr | limitTo(30) }}
                          <ion-icon v-if="value.businessTaskStatus === 4" name="alert-circle-outline"
                                    style="color: #D8152F;"></ion-icon>
                          <ion-icon v-if="value.businessTaskStatus === 3" name="checkmark-circle-outline"
                                    style="color: #08A747;"/>
                        </span>
                      </div>
                      <ion-icon @click="toggleOpen(value)" :style="value.open ? 'transform: rotate(180deg);' : ''"
                                name="chevron-down-outline"></ion-icon>
                    </div>
                    <div class="active-body" v-if="value.open">
                      <span class="body-date">
                        {{ value.taskDateInit | formatDateDefault }}
                         -
                        {{ value.taskDateEnd | formatDateDefault }}
                      </span>
                      <span class="body-status"
                            :style="value.businessTaskStatus === 4 ? 'color: #D8152F;' : value.businessTaskStatus === 3 ? 'color: #08A747' : ''">
                        {{ value.businessTaskStatusStr }}
                        <ion-icon v-if="value.businessTaskStatus === 4 || value.businessTaskStatus === 1"
                                  name="alert-circle-outline"
                                  :style="value.businessTaskStatus === 4 ? 'color: #D8152F;' : 'color: #F9CA04'"/>
                      </span>
                      <span class="body-responsible">Responsável: <b>{{ value.who }}</b></span>
                      <span class="body-obs">{{ value.description }}</span>
                      <button class="body-btn" @click="toggleDropdown(value)">
                        <ion-icon name="ellipsis-horizontal"></ion-icon>
                        <ul class="listdrop" v-if="value.showDropdown">
                          <li @click="changeStatusActivie(value.id)">Alterar status</li>
                          <li class="listdrop-delete" @click="confirmRemove(value, index)">Deletar</li>
                        </ul>
                      </button>
                    </div>
                  </div>
                  <button v-on:click="setActive()" class="btn-add-active" type="submit">
                    <span>Criar atividade</span>
                  </button>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 default-box box-create-tag">
                  <h5>Adicionar TAG <span @click="modalCreateTag()">Criar TAG</span></h5>
                  <div class="box-tag">
                    <span v-for="(tag, index) in dataTags" :key="index"
                          v-on:click="addTag(tag.name, tag.color)" class="tag"
                          v-bind:style="{'background': tag.color}">
                      {{ tag.name }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-8">
                <div class="col-xs-12 col-sm-12 col-md-12 default-box box-company-obs">
                  <div class="form-group box-company-obs-content">
                    <div class="module-type">
                      <span v-if="dataCompany.moduleTypeStr == 'MarQPonto'" class="tag-type tag-point">
                        {{ dataCompany.moduleTypeStr }}
                      </span>
                      <span v-else-if="dataCompany.moduleTypeStr == 'Beneficios'" class="tag-type tag-benefits">
                        {{ dataCompany.moduleTypeStr }}
                      </span>
                      <span v-else-if="dataCompany.moduleTypeStr == 'MarQ+Beneficios'"
                            class="tag-type tag-beneflex-point">
                        {{ dataCompany.moduleTypeStr }}
                      </span>
                      <span v-else class="tag-type">
                        {{ dataCompany.moduleTypeStr }}
                      </span>

                      <span class="company-profile">
                        <btn-change @emit-click="tooltipOpenned = !tooltipOpenned"
                                    :label="'Perfil ' + companyTier">
                          <template>
                            <tooltip-default @close-tooltip="tooltipOpenned = !tooltipOpenned"
                                             :show-tooltip="tooltipOpenned" top="40px" left="-186px" have-icon="true"
                                             title="Perfil da empresa"
                                             icon="swap-horizontal-outline">
                              <template>
                                <div class="tooltip-body">
                                  <div class="body-status">
                                    <div class="content-input">
                                      <input type="radio" class="onboarding" name="A" value="A"
                                             v-bind:checked="valueCurrentProfile === 'A'"
                                             @click="valueProfile('A')"/>
                                      <input type="radio" class="B" name="B" value="B"
                                             v-bind:checked="valueCurrentProfile === 'B'"
                                             @click="valueProfile('B')"/>
                                      <input type="radio" class="middle" name="C" value="C"
                                             v-bind:checked="valueCurrentProfile === 'C'"
                                             @click="valueProfile('C')"/>
                                      <input type="radio" class="ongoing" name="D" value="D"
                                             v-bind:checked="valueCurrentProfile === 'D'"
                                             @click="valueProfile('D')"/>
                                      <input type="radio" class="ongoing" name="E" value="E"
                                             v-bind:checked="valueCurrentProfile === 'E'"
                                             @click="valueProfile('E')"/>
                                    </div>
                                    <div class="content-span">
                                      <span class="span-trial">Perfil A</span>
                                      <span class="span-onboarding">Perfil B</span>
                                      <span class="span-mid">Perfil C</span>
                                      <span class="span-ongoing">Perfil D</span>
                                      <span class="span-ongoing">Perfil E</span>
                                    </div>
                                    <span class="btn-change-plan">
                                      <btn-blue @emit-click="setNewProfile" label="Alterar"
                                      />
                                    </span>
                                  </div>
                                </div>
                              </template>
                            </tooltip-default>
                          </template>
                        </btn-change>
                      </span>

                      <span class="btn-trial" v-if="dataCompany.clientJourney === 0">
                        Trial
                        <a title="Gerenciar Onboarding" v-on:click="statusOnboarding()">
                          <ion-icon name="swap-horizontal-outline"></ion-icon>
                        </a>
                      </span>
                      <span class="btn-onboarding" v-if="dataCompany.clientJourney === 1">
                        Onboarding
                        <a title="Gerenciar Onboarding" v-on:click="statusOnboarding()">
                          <ion-icon name="swap-horizontal-outline"></ion-icon>
                        </a>
                      </span>
                      <span class="btn-middle" v-if="dataCompany.clientJourney === 2">
                        Mid
                        <a title="Gerenciar Onboarding" v-on:click="statusOnboarding()">
                          <ion-icon name="swap-horizontal-outline"></ion-icon>
                        </a>
                      </span>
                      <span class="btn-ongoing" v-if="dataCompany.clientJourney === 3">
                        Ongoing
                        <a title="Gerenciar Onboarding" v-on:click="statusOnboarding()">
                          <ion-icon name="swap-horizontal-outline"></ion-icon>
                        </a>
                      </span>
                      <span class="btn-white-label " v-if="dataCompany.clientJourney === 4">
                        Resale
                      </span>

                      <!--                      <div class="onboarding-group">-->
                      <!--                      -->
                      <!--                      </div>-->
                    </div>
                    <span class="owner-actual">CSM: {{ ownerActualFormated }}</span>
                    <div class="first-contact">
                      <span @click="signalContact()" class="signal-contact">Sinalizar contato</span>
                      <span class="contact-msg" v-if="!sinalizedContact.clientWasContacted">Ainda não foi sinalizado contato.</span>
                      <span class="contact-msg" v-if="sinalizedContact.clientWasContacted">Sinalizou contato em
                        {{ sinalizedContact.dataLastClientWasContacted | formatDate }}
                        às
                        {{ sinalizedContact.dataLastClientWasContacted | formatHors24 }}.
                      </span>
                    </div>
                    <label class="label-span"><span>Ação</span></label>
                    <select v-model="type" @change="clearInput()" id="fromWhoEmail" name="fromWhoEmail" required
                            :disabled="loadingAttach || loadingSendObs">
                      <option value="99">Anexos</option>
                      <option value="0">Intercom</option>
                      <option value="1">Ligação</option>
                      <option value="2">Whatsapp</option>
                      <option value="3">E-Mail</option>
                      <option value="4">Msg</option>
                      <option value="5">Retenção</option>
                      <option value="6">Onboarding</option>
                      <option value="7">NPS</option>
                      <option value="8">Sistema</option>
                      <option value="10">Financeiro</option>
                      <option value="11">Possível Churn</option>
                      <option value="12">FollowUp Automático</option>
                      <option value="18">Middle</option>
                      <option value="19">Ongoing</option>
                      <option value="20">Boas vindas</option>
                      <option value="21">Treinamento</option>
                      <option value="22">Parametrização</option>
                      <option value="23">Despedida</option>
                      <option value="24">Solicitação cancelamento</option>
                      <option value="27">Beneflex</option>
                    </select>
                    <label class="label-span">
                      <span v-if="type == 99">Anexos</span>
                      <span v-else>Informações</span>
                    </label>
                    <div v-if="type == 99" class="input-file-group">
                      <input @change="addAttach" @click="clearInput();" value="" class="input-file" type="file"
                             id="fileFunel" name="fileFunel" multiple :disabled="loadingAttach"/>
                      <ion-icon v-if="successAttach" name="checkmark-circle-outline" class="ion-attach ion-success"/>
                      <ion-icon v-if="errorAttach" @click="clearInput()" name="close-circle-outline"
                                class="ion-attach ion-error"/>
                      <ion-icon v-if="loadingAttach" name="reload-circle-outline" class="ion-attach ion-loading"/>
                      <span v-if="errorAttach" class="remove-attack">* Para remover o anexo com erro, clique no icone acima.</span>
                    </div>
                    <textarea v-else id="txtarea" v-model="obs"
                              placeholder="Deseja adicionar algum comentário ou anotação sobre a atividade realizada?"></textarea>
                    <button @click="createObs(0)" :disabled="loadingSendObs"
                            :style="type == 99 ? 'z-index: -10000;' : ''"
                            v-bind:class="{'disable': loadingSendObs}" class="btn-send-obs btn-default" type="submit">
                      <span v-if="!loadingSendObs">Salvar</span>
                      <div class="loading-btn" v-else>
                        <div class="spinner-btn">
                          <div class="rect1"></div>
                          <div class="rect2"></div>
                          <div class="rect3"></div>
                          <div class="rect4"></div>
                          <div class="rect5"></div>
                        </div>
                      </div>
                    </button>
                  </div>
                  <h5 class="h5t">
                    <ion-icon @click="changeBoxFilters(1)" v-if="!showFiltersSecondary"
                              name="caret-down-outline"></ion-icon>
                    <ion-icon @click="changeBoxFilters(2)" v-if="showFiltersSecondary"
                              name="caret-up-outline"></ion-icon>
                    <span class="span-all" v-on:click="changeList(15)"
                          v-bind:class="{'active-title': listTypeToShow === 15}">Todos
                    </span>
                    <span class="span-all" v-on:click="changeList(99)"
                          v-bind:class="{'active-title': listTypeToShow === 99}">Anexos
                    </span>
                    <span class="span-financial" v-on:click="changeList(17)"
                          v-bind:class="{'active-title': listTypeToShow === 17}">Financeiro
                    </span>
                    <span class="span-notifications" v-on:click="changeList(16)"
                          v-bind:class="{'active-title': listTypeToShow === 16}">Notificações
                    </span>
                    <span class="span-notifications" v-on:click="changeList(27)"
                          v-bind:class="{'active-title': listTypeToShow === 27}">Beneflex
                    </span>
                    <span v-if="showFiltersSecondary" v-for="(filter, index) in businessNoteTypeFilter" :key="index"
                          v-on:click="changeList(filter.value)"
                          v-bind:class="{'active-title': listTypeToShow === filter.value}">{{ filter.title }}
                    </span>
                  </h5>
                  <div v-for="filterAll in businessNoteTypeFilter">
                    <div v-if="listTypeToShow === filterAll.value" v-for="(d, index) in dataTimeline" :key="index"
                         class="content-timeline">
                      <div class="timeline-line" v-if="d.businessNoteType === filterAll.value">
                        <i v-if="d.businessNoteType === 0" class="fa fa-comments jivo" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 1" class="fa fa-phone phone" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 2" class="fa fa-whatsapp wts" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType ===3" class="fa fa-envelope-o email" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 4" class="fa fa-commenting-o msg" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 5" class="fa fa-comments jivo" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 6" class="fa fa-smile-o onbording" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 7" class="fa fa-sticky-note-o nps" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 8" class="fa fa-flag-o system" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 10" class="fa fa-exclamation-triangle warning"
                           aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 11" class="fa fa-sort-amount-asc pchurn" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 12" class="fa fa-magic magic" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 13" class="fa fa-exclamation-circle defaulter"
                           aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 14" class="fa fa-refresh refresh" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 18" class="fa fa-smile-o middle"
                           aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 19" class="fa fa-smile-o ongoing" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 20" class="fa fa-sign-in welcome" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 21" class="fa fa-user-o trainee" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 22" class="fa fa-product-hunt parameter"
                           aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 23" class="fa fa-fire farewell" aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 24" class="fa fa-frown-o cancellation-request"
                           aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 25" class="fa fa-repeat renovation-request"
                           aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 26" class="fa fa-wifi contact-signal contact-signal-icon"
                           aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 27" class="fa fa-credit-card contact-signal contact-signal-icon"
                           aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 55 || d.businessNoteType === 56" class="fa fa-unlock-alt warning"
                           aria-hidden="true"></i>
                        <i v-if="d.businessNoteType >= 28 && d.businessNoteType <= 45" class="fa fa-flag-o system"
                           aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 99" class="fa fa-paperclip attachment attachment-icon"
                           aria-hidden="true"></i>
                        <img v-if="d.businessNoteType === 39"
                             style="top: 15px; max-width: 60px !important; height: 60px !important;"
                             src="../../../../assets/img/nps-flag.png"
                             alt="img-nps">
                        <img v-if="d.businessNoteType === 40"
                             style="top: 15px; max-width: 60px !important; height: 60px !important;"
                             src="../../../../assets/img/nps-flag.png"
                             alt="img-nps">
                      </div>
                      <div class="timeline-align">
                        <div v-if="d.businessNoteType === filterAll.value" class="timeline-data"
                             v-bind:class="{'payment-pending': d.businessNoteType === 13}">
                          <p class="user-note">{{ d.userName }}
                            <span class="date">{{ d.createdAt | formatFullDate24 }}</span>
                            <span class="tag jivo" v-if="d.businessNoteType === 0">Intercom</span>
                            <span class="tag call" v-if="d.businessNoteType === 1">Ligação</span>
                            <span class="tag wts" v-if="d.businessNoteType === 2">WhatsApp</span>
                            <span class="tag email" v-if="d.businessNoteType === 3">E-mail</span>
                            <span class="tag msg" v-if="d.businessNoteType === 4">Msg</span>
                            <span class="tag jivo" v-if="d.businessNoteType === 5">Retenção</span>
                            <span class="tag onbording" v-if="d.businessNoteType === 6">Onboarding</span>
                            <span class="tag system" v-if="d.businessNoteType === 8">Sistema</span>
                            <span class="tag warning" v-if="d.businessNoteType === 10">Financeiro</span>
                            <span class="tag pchurn" v-if="d.businessNoteType === 11">Possível Churn</span>
                            <span class="tag magic" v-if="d.businessNoteType === 12">FollowUp Automatico</span>
                            <span class="tag defaulter" v-if="d.businessNoteType === 13">Inadimblente</span>
                            <span class="tag refresh" v-if="d.businessNoteType === 14">Alteração de etapa</span>
                            <span class="tag middle" v-if="d.businessNoteType === 18">Middle</span>
                            <span class="tag ongoing" v-if="d.businessNoteType === 19">Ongoing</span>
                            <span class="tag welcome" v-if="d.businessNoteType === 20">Boas vindas</span>
                            <span class="tag trainee" v-if="d.businessNoteType === 21">Treinamento</span>
                            <span class="tag parameter" v-if="d.businessNoteType === 22">Parametrização</span>
                            <span class="tag farewell" v-if="d.businessNoteType === 23">Despedida</span>
                            <span class="tag cancellation-request" v-if="d.businessNoteType === 24">Solicitação cancelamento</span>
                            <span class="tag renovation-request" v-if="d.businessNoteType === 25">Renovação</span>
                            <span class="tag warning" v-if="d.businessNoteType === 55">Upsell</span>
                            <span class="tag warning" v-if="d.businessNoteType === 56">Liberação</span>
                            <span class="tag contact-signal" v-if="d.businessNoteType === 26">Sinalizado contato</span>
                            <span class="tag contact-signal" v-if="d.businessNoteType === 27">Beneflex</span>
                            <span class="tag system" v-if="d.businessNoteType === 28">Acesso contador</span>
                            <span class="tag system"
                                  v-if="d.businessNoteType === 29">Importação dados de benefício</span>
                            <span class="tag system"
                                  v-if="d.businessNoteType === 30">Atualização fuso horário do turno</span>
                            <span class="tag system"
                                  v-if="d.businessNoteType === 31">Atualização do turno para 24 horas</span>
                            <span class="tag system" v-if="d.businessNoteType === 32">Escala</span>
                            <span class="tag system" v-if="d.businessNoteType === 33">MarQTab</span>
                            <span class="tag system" v-if="d.businessNoteType === 34">Dias duplicados</span>
                            <span class="tag system" v-if="d.businessNoteType === 35">Sistema</span>
                            <span class="tag system" v-if="d.businessNoteType === 36">Sistema</span>
                            <span class="tag nps" v-if="d.businessNoteType === 39">NPS</span>
                            <span class="tag nps" v-if="d.businessNoteType === 40">NPS</span>
                          </p>
                          <p v-if="d.text" class="text">
                            <span v-html="d.text" style="font-weight: normal">
                            </span>
                            <span v-if="d.businessNoteType === 4">(Normal)</span>
                            <span v-if="d.businessNoteType === 6">(Onboarding)</span>
                            <span v-if="d.businessNoteType === 11">(Churn)</span>
                          </p>
                          <p v-on:click="deleteNote(index, d)" class="remove">
                            <i class="fa fa-times" aria-hidden="true"></i>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="listTypeToShow === 15 && dataTimeLineFixed.length" v-for="(d, index) in dataTimeLineFixed"
                       :key="d.id" class="content-timeline">
                    <div class="timeline-line">
                      <i v-if="d.businessNoteType === 0" class="fa fa-comments jivo" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 1" class="fa fa-phone phone" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 2" class="fa fa-whatsapp wts" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 3" class="fa fa-envelope-o email" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 4" class="fa fa-commenting-o msg" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 5" class="fa fa-comments jivo" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 6" class="fa fa-smile-o onbording" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 7" class="fa fa-sticky-note-o nps" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 8" class="fa fa-flag-o system" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 10" class="fa fa-exclamation-triangle warning"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 11" class="fa fa-sort-amount-asc pchurn" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 12" class="fa fa-magic magic" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 13" class="fa fa-exclamation-circle defaulter"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 14" class="fa fa-refresh refresh" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 18" class="fa fa-smile-o middle" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 19" class="fa fa-smile-o ongoing" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 20" class="fa fa-sign-in welcome" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 21" class="fa fa-user-o trainee" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 22" class="fa fa-product-hunt parameter" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 23" class="fa fa-fire farewell" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 24" class="fa fa-frown-o cancellation-request"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 25" class="fa fa-repeat renovation-request"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 26" class="fa fa-wifi contact-signal contact-signal-icon"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 27" class="fa fa-credit-card contact-signal contact-signal-icon"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 55 || d.businessNoteType === 56" class="fa fa-unlock-alt warning"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType >= 28 && d.businessNoteType <= 45" class="fa fa-flag-o system"
                         aria-hidden="true"></i>
                      <img v-if="d.businessNoteType === 39"
                           style="top: 15px; max-width: 60px !important; height: 60px !important;"
                           src="../../../../assets/img/nps-flag.png"
                           alt="img-nps">
                      <img v-if="d.businessNoteType === 40"
                           style="top: 15px; max-width: 60px !important; height: 60px !important;"
                           src="../../../../assets/img/nps-flag.png"
                           alt="img-nps">
                      <img v-if="d.businessNoteType === 88" src="../../../../assets/img/emote/neutro-empty.png"
                           alt="img">
                      <ion-icon v-if="d.businessNoteType === 89" name="link-outline"></ion-icon>
                      <i v-if="d.businessNoteType === 99" class="fa fa-paperclip attachment attachment-icon"
                         aria-hidden="true"></i>
                    </div>
                    <!-- timeline fixada -->
                    <div class="timeline-align">
                      <div class="timeline-data bg-fixed" v-bind:class="{'payment-pending': d.businessNoteType === 13}">
                        <p class="user-note">{{ d.userName }}
                          <span class="date">{{ d.createdAt | formatFullDate24 }}</span>
                          <span class="tag jivo" v-if="d.businessNoteType === 0">Intercom</span>
                          <span class="tag call" v-if="d.businessNoteType === 1">Ligação</span>
                          <span class="tag wts" v-if="d.businessNoteType === 2">WhatsApp</span>
                          <span class="tag email" v-if="d.businessNoteType === 3">E-mail</span>
                          <span class="tag msg" v-if="d.businessNoteType === 4">Msg</span>
                          <span class="tag jivo" v-if="d.businessNoteType === 5">Retenção</span>
                          <span class="tag onbording" v-if="d.businessNoteType === 6">Onboarding</span>
                          <span class="tag nps" v-if="d.businessNoteType === 7">NPS</span>
                          <span class="tag system" v-if="d.businessNoteType === 8">Sistema</span>
                          <span class="tag warning" v-if="d.businessNoteType === 10">Financeiro</span>
                          <span class="tag pchurn" v-if="d.businessNoteType === 11">Possível Churn</span>
                          <span class="tag magic" v-if="d.businessNoteType === 12">FollowUp Automatico</span>
                          <span class="tag defaulter" v-if="d.businessNoteType === 13">Inadimplente</span>
                          <span class="tag refresh" v-if="d.businessNoteType === 14">Alteração de etapa</span>
                          <span class="tag middle"
                                v-if="d.businessNoteType === 18">Middle</span>
                          <span class="tag ongoing" v-if="d.businessNoteType === 19">Ongoing</span>
                          <span class="tag welcome" v-if="d.businessNoteType === 20">Boas vindas</span>
                          <span class="tag trainee" v-if="d.businessNoteType === 21">Treinamento</span>
                          <span class="tag parameter" v-if="d.businessNoteType === 22">Parametrização</span>
                          <span class="tag farewell" v-if="d.businessNoteType === 23">Despedida</span>
                          <span class="tag cancellation-request" v-if="d.businessNoteType === 24">Solicitação cancelamento</span>
                          <span class="tag renovation-request" v-if="d.businessNoteType === 25">Renovação</span>
                          <span class="tag warning" v-if="d.businessNoteType === 55">Upsell</span>
                          <span class="tag warning" v-if="d.businessNoteType === 56">Liberação</span>
                          <span class="tag contact-signal" v-if="d.businessNoteType === 26">Sinalizado contato</span>
                          <span class="tag contact-signal" v-if="d.businessNoteType === 27">Beneflex</span>
                          <span class="tag system" v-if="d.businessNoteType === 28">Acesso contador</span>
                          <span class="tag system" v-if="d.businessNoteType === 29">Importação dados de benefício</span>
                          <span class="tag system"
                                v-if="d.businessNoteType === 30">Atualização fuso horário do turno</span>
                          <span class="tag system"
                                v-if="d.businessNoteType === 31">Atualização do turno para 24 horas</span>
                          <span class="tag system" v-if="d.businessNoteType === 32">Escala</span>
                          <span class="tag system" v-if="d.businessNoteType === 33">MarQTab</span>
                          <span class="tag system" v-if="d.businessNoteType === 34">Dias duplicados</span>
                          <span class="tag system" v-if="d.businessNoteType === 35">Sistema</span>
                          <span class="tag system" v-if="d.businessNoteType === 36">Sistema</span>
                          <span class="tag nps" v-if="d.businessNoteType === 39 || d.businessNoteType === 40">NPS</span>
                          <span class="tag status-csat" v-if="d.businessNoteType === 88 || d.businessNoteType === 89">CSAT</span>
                        </p>
                        <p class="text" :style="{'max-height': d.height}">
                          <span class="text-attachments" v-if="d.businessNoteType === 99">
                            <span v-if="d.text.includes('.pdf')" class="text-attachments-pdf">
                              <span>Arquivo PDF</span>
                              <a :href="d.text" target="_blank">Visualizar</a>
                            </span>
                            <span
                              v-else-if="d.text.includes('.excel') || d.text.includes('.xlsx') || d.text.includes('.csv')"
                              class="text-attachments-excel">
                              <span>Arquivo Excel</span>
                              <a :href="d.text" target="_blank">Visualizar</a>
                            </span>
                            <a
                              v-else-if="d.text.includes('.png') || d.text.includes('.jpeg') || d.text.includes('.svg') || d.text.includes('.webp')"
                              :href="d.text" target="_blank">
                              <img class="text-attachments-img" :src="d.text" alt="Anexo">
                            </a>
                            <span v-else class="text-attachments-other">
                              <span>Anexo</span>
                              <a :href="d.text" target="_blank">Visualizar</a>
                            </span>
                          </span>
                          <!-- //textnps -->
                          <span v-for="(d, index) in title" :key="index" class="text-csat">
                            <template v-if="d.businessNoteType === 39">
                              <p><b>{{ d }}</b></p>
                            </template>
                            <template v-if="d.businessNoteType === 40">
                              <div>
                                <p><b>{{ d }}</b></p>
                                <p v-for="(res, resIndex) in respondedBy" :key="resIndex">{{ res }}</p>
                                <p v-for="(nps, npsIndex) in npsScore" :key="npsIndex"><b>Nota do NPS:</b> {{ nps }}</p>
                                <p v-for="(npsType, npsTypeIndex) in npsType" :key="npsTypeIndex"><b>{{
                                    npsType
                                  }}</b></p>
                                <p v-for="(comment, commentIndex) in comment"
                                   :key="commentIndex"><b>Comentário:</b> {{ comment }}</p>
                              </div>
                            </template>
                          </span>
                          <span class="text-csat" v-if="d.businessNoteType === 88">
                            <span class="csat-head">{{ d.textConvert.Description }}</span>
                            <span class="csat-content">
                              <b>Nota expêriencia: </b>
                              <span v-if="d.textConvert.ExperienceScore === 1">1 - Muito ruim</span>
                              <span v-else-if="d.textConvert.ExperienceScore === 2">2 - Ruim</span>
                              <span v-else-if="d.textConvert.ExperienceScore === 3">3 - Médio</span>
                              <span v-else-if="d.textConvert.ExperienceScore === 4">4 - Bom</span>
                              <span v-else-if="d.textConvert.ExperienceScore === 5">5 - Excelente</span>
                              <span v-else> - </span>
                            </span>
                            <span class="csat-content">
                              <b>Nota atendimento: </b>
                              <span v-if="d.textConvert.AttendingScore === 1">1 - Muito ruim</span>
                              <span v-else-if="d.textConvert.AttendingScore === 2">2 - Ruim</span>
                              <span v-else-if="d.textConvert.AttendingScore === 3">3 - Médio</span>
                              <span v-else-if="d.textConvert.AttendingScore === 4">4 - Bom</span>
                              <span v-else-if="d.textConvert.AttendingScore === 5">5 - Excelente</span>
                              <span v-else> - </span>
                            </span>
                            <span class="csat-content">
                              <b>Comentário: </b>
                              <span>{{ d.textConvert.Comment }}</span>
                            </span>
                            <span class="csat-content">
                              <span>-------------</span>
                            </span>
                            <span class="csat-content">
                              <b>Etapa: </b>
                              <span v-if="d.textConvert.Journey === 1">Trial</span>
                              <span v-else-if="d.textConvert.Journey === 2">Onboarding</span>
                              <span v-else-if="d.textConvert.Journey === 3">Mid</span>
                              <span v-else-if="d.textConvert.Journey === 4">Ongoing</span>
                              <span v-else> - </span>
                            </span>
                            <span class="csat-content">
                              <b>Responsável: </b>
                              <span>{{ d.textConvert.UserResponsible }}</span>
                            </span>
                          </span>
                          <span class="text-csat" v-else-if="d.businessNoteType === 89">
                            <span class="csat-head">{{ d.textConvert.Description }}</span>
                            <span class="csat-content">
                              <b>Etapa: </b>
                              <span v-if="d.textConvert.Journey === 1">Trial</span>
                              <span v-else-if="d.textConvert.Journey === 2">Onboarding</span>
                              <span v-else-if="d.textConvert.Journey === 3">Mid</span>
                              <span v-else-if="d.textConvert.Journey === 4">Ongoing</span>
                              <span v-else> - </span>
                            </span>
                          </span>
                          <span v-else-if="!d.isSelect" class="have-height" v-html="d.text"
                                style="font-weight: normal;"></span>
                          <span v-else-if="d.isSelect" v-html="d.text" style="font-weight: normal;"></span>
                          <span v-if="d.businessNoteType === 4">(Normal)</span>
                          <span v-if="d.businessNoteType === 6">(Onboarding)</span>
                          <span v-if="d.businessNoteType === 11">(Churn)</span>
                          <a v-if="d.text.length > 600 && !d.isSelect" @click.prevent="controlHeight(d)">
                            <span>Ver mais</span>
                          </a>
                          <a v-if="d.text.length > 600 && d.isSelect" class="to-hide"
                             @click.prevent="controlHeight(d)">
                            <span><ion-icon name="chevron-up-outline"></ion-icon></span>
                          </a>
                        </p>
                        <p v-on:click="deleteNote(index, d)" class="remove">
                          <i class="fa fa-times" aria-hidden="true"></i>
                        </p>
                        <p @click="fixedNote(index, d)" class="fixed">
                          <img src="../../../../assets/img/fixado.png">
                        </p>
                      </div>
                    </div>
                  </div>

                  <div v-if="listTypeToShow === 15" v-for="(d, index) in dataTimeline" :key="index"
                       class="content-timeline">
                    <div class="timeline-line">
                      <i v-if="d.businessNoteType === 0" class="fa fa-comments jivo" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 1" class="fa fa-phone phone" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 2" class="fa fa-whatsapp wts" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 3" class="fa fa-envelope-o email" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 4" class="fa fa-commenting-o msg" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 5" class="fa fa-comments jivo" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 6" class="fa fa-smile-o onbording" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 7" class="fa fa-sticky-note-o nps" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 8" class="fa fa-flag-o system" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 10" class="fa fa-exclamation-triangle warning"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 11" class="fa fa-sort-amount-asc pchurn" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 12" class="fa fa-magic magic" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 13" class="fa fa-exclamation-circle defaulter"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 14" class="fa fa-refresh refresh" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 18" class="fa fa-smile-o middle" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 19" class="fa fa-smile-o ongoing" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 20" class="fa fa-sign-in welcome" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 21" class="fa fa-user-o trainee" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 22" class="fa fa-product-hunt parameter" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 23" class="fa fa-fire farewell" aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 24" class="fa fa-frown-o cancellation-request"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 25" class="fa fa-repeat renovation-request"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 26" class="fa fa-wifi contact-signal contact-signal-icon"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 27" class="fa fa-credit-card contact-signal contact-signal-icon"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType === 55 || d.businessNoteType === 56" class="fa fa-unlock-alt warning"
                         aria-hidden="true"></i>
                      <i v-if="d.businessNoteType >= 28 && d.businessNoteType <= 45" class="fa fa-flag-o system"
                         aria-hidden="true"></i>
                      <img v-if="d.businessNoteType === 39"
                           style="top: 15px; max-width: 60px !important; height: 60px !important;"
                           src="../../../../assets/img/nps-flag.png"
                           alt="img-nps">
                      <img v-if="d.businessNoteType === 40"
                           style="top: 15px; max-width: 60px !important; height: 60px !important;"
                           src="../../../../assets/img/nps-flag.png"
                           alt="img-nps">
                      <img v-if="d.businessNoteType === 88" src="../../../../assets/img/emote/neutro-empty.png"
                           alt="img">
                      <ion-icon v-if="d.businessNoteType === 89" name="link-outline"></ion-icon>
                      <i v-if="d.businessNoteType === 99" class="fa fa-paperclip attachment attachment-icon"
                         aria-hidden="true"></i>
                    </div>
                    <!-- timeline nao fixada -->
                    <div class="timeline-align">
                      <div class="timeline-data" v-bind:class="{'payment-pending': d.businessNoteType === 13}">
                        <p class="user-note">{{ d.userName }}
                          <span class="date">{{ d.createdAt | formatFullDate24 }}</span>
                          <span class="tag jivo" v-if="d.businessNoteType === 0">Intercom</span>
                          <span class="tag call" v-if="d.businessNoteType === 1">Ligação</span>
                          <span class="tag wts" v-if="d.businessNoteType === 2">WhatsApp</span>
                          <span class="tag email" v-if="d.businessNoteType === 3">E-mail</span>
                          <span class="tag msg" v-if="d.businessNoteType === 4">Msg</span>
                          <span class="tag jivo" v-if="d.businessNoteType === 5">Retenção</span>
                          <span class="tag onbording" v-if="d.businessNoteType === 6">Onboarding</span>
                          <span class="tag nps" v-if="d.businessNoteType === 7">NPS</span>
                          <span class="tag system" v-if="d.businessNoteType === 8">Sistema</span>
                          <span class="tag warning" v-if="d.businessNoteType === 10">Financeiro</span>
                          <span class="tag pchurn" v-if="d.businessNoteType === 11">Possível Churn</span>
                          <span class="tag magic" v-if="d.businessNoteType === 12">FollowUp Automatico</span>
                          <span class="tag defaulter" v-if="d.businessNoteType === 13">Inadimplente</span>
                          <span class="tag refresh" v-if="d.businessNoteType === 14">Alteração de etapa</span>
                          <span class="tag middle"
                                v-if="d.businessNoteType === 18">Middle</span>
                          <span class="tag ongoing" v-if="d.businessNoteType === 19">Ongoing</span>
                          <span class="tag welcome" v-if="d.businessNoteType === 20">Boas vindas</span>
                          <span class="tag trainee" v-if="d.businessNoteType === 21">Treinamento</span>
                          <span class="tag parameter" v-if="d.businessNoteType === 22">Parametrização</span>
                          <span class="tag farewell" v-if="d.businessNoteType === 23">Despedida</span>
                          <span class="tag cancellation-request" v-if="d.businessNoteType === 24">Solicitação cancelamento</span>
                          <span class="tag renovation-request" v-if="d.businessNoteType === 25">Renovação</span>
                          <span class="tag warning" v-if="d.businessNoteType === 55">Upsell</span>
                          <span class="tag warning" v-if="d.businessNoteType === 56">Liberação</span>
                          <span class="tag contact-signal" v-if="d.businessNoteType === 26">Sinalizado contato</span>
                          <span class="tag contact-signal" v-if="d.businessNoteType === 27">Beneflex</span>
                          <span class="tag system" v-if="d.businessNoteType === 28">Acesso contador</span>
                          <span class="tag system" v-if="d.businessNoteType === 29">Importação dados de benefício</span>
                          <span class="tag system"
                                v-if="d.businessNoteType === 30">Atualização fuso horário do turno</span>
                          <span class="tag system"
                                v-if="d.businessNoteType === 31">Atualização do turno para 24 horas</span>
                          <span class="tag system" v-if="d.businessNoteType === 32">Escala</span>
                          <span class="tag system" v-if="d.businessNoteType === 33">MarQTab</span>
                          <span class="tag system" v-if="d.businessNoteType === 34">Dias duplicados</span>
                          <span class="tag system" v-if="d.businessNoteType === 35">Sistema</span>
                          <span class="tag system" v-if="d.businessNoteType === 36">Sistema</span>
                          <span class="tag nps" v-if="d.businessNoteType === 39">NPS</span>
                          <span class="tag nps" v-if="d.businessNoteType === 40">NPS</span>
                          <span class="tag status-csat" v-if="d.businessNoteType === 88 || d.businessNoteType === 89">CSAT</span>
                        </p>
                        <p class="text" :style="{'max-height': d.height}">
                          <span class="text-attachments" v-if="d.businessNoteType === 99">
                            <span v-if="d.text.includes('.pdf')" class="text-attachments-pdf">
                              <span>Arquivo PDF</span>
                              <a :href="d.text" target="_blank">Visualizar</a>
                            </span>
                            <span
                              v-else-if="d.text.includes('.excel') || d.text.includes('.xlsx') || d.text.includes('.csv')"
                              class="text-attachments-excel">
                              <span>Arquivo Excel</span>
                              <a :href="d.text" target="_blank">Visualizar</a>
                            </span>
                            <a
                              v-else-if="d.text.includes('.png') || d.text.includes('.jpeg') || d.text.includes('.svg') || d.text.includes('.webp')"
                              :href="d.text" target="_blank">
                              <img class="text-attachments-img" :src="d.text" alt="Anexo">
                            </a>
                            <span v-else class="text-attachments-other">
                              <span>Anexo</span>
                              <a :href="d.text" target="_blank">Visualizar</a>
                            </span>
                          </span>
                          <!-- //textnps -->
                          <span v-for="(d, index) in title" :key="index" class="text-csat">
                            <template v-if="d.businessNoteType === 39">
                              <p><b>{{ d }}</b></p>
                            </template>
                            <template v-if="d.businessNoteType === 40">
                              <div>
                                <p><b>{{ d }}</b></p>
                                <p v-for="(res, resIndex) in respondedBy" :key="resIndex">{{ res }}</p>
                                <p v-for="(nps, npsIndex) in npsScore" :key="npsIndex"><b>Nota do NPS:</b> {{ nps }}</p>
                                <p v-for="(npsType, npsTypeIndex) in npsType" :key="npsTypeIndex"><b>{{
                                    npsType
                                  }}</b></p>
                                <p v-for="(comment, commentIndex) in comment"
                                   :key="commentIndex"><b>Comentário:</b> {{ comment }}</p>
                              </div>
                            </template>
                          </span>
                          <span class="text-csat" v-if="d.businessNoteType === 88">
                            <span class="csat-head">{{ d.textConvert.Description }}</span>
                            <span class="csat-content">
                              <b>Nota expêriencia: </b>
                              <span v-if="d.textConvert.ExperienceScore === 1">1 - Muito ruim</span>
                              <span v-else-if="d.textConvert.ExperienceScore === 2">2 - Ruim</span>
                              <span v-else-if="d.textConvert.ExperienceScore === 3">3 - Médio</span>
                              <span v-else-if="d.textConvert.ExperienceScore === 4">4 - Bom</span>
                              <span v-else-if="d.textConvert.ExperienceScore === 5">5 - Excelente</span>
                              <span v-else> - </span>
                            </span>
                            <span class="csat-content">
                              <b>Nota atendimento: </b>
                              <span v-if="d.textConvert.AttendingScore === 1">1 - Muito ruim</span>
                              <span v-else-if="d.textConvert.AttendingScore === 2">2 - Ruim</span>
                              <span v-else-if="d.textConvert.AttendingScore === 3">3 - Médio</span>
                              <span v-else-if="d.textConvert.AttendingScore === 4">4 - Bom</span>
                              <span v-else-if="d.textConvert.AttendingScore === 5">5 - Excelente</span>
                              <span v-else> - </span>
                            </span>
                            <span class="csat-content">
                              <b>Comentário: </b>
                              <span>{{ d.textConvert.Comment }}</span>
                            </span>
                            <span class="csat-content">
                              <span>-------------</span>
                            </span>
                            <span class="csat-content">
                              <b>Etapa: </b>
                              <span v-if="d.textConvert.Journey === 1">Trial</span>
                              <span v-else-if="d.textConvert.Journey === 2">Onboarding</span>
                              <span v-else-if="d.textConvert.Journey === 3">Mid</span>
                              <span v-else-if="d.textConvert.Journey === 4">Ongoing</span>
                              <span v-else> - </span>
                            </span>
                            <span class="csat-content">
                              <b>Responsável: </b>
                              <span>{{ d.textConvert.UserResponsible }}</span>
                            </span>
                          </span>
                          <span class="text-csat" v-else-if="d.businessNoteType === 89">
                            <span class="csat-head">{{ d.textConvert.Description }}</span>
                            <span class="csat-content">
                              <b>Etapa: </b>
                              <span v-if="d.textConvert.Journey === 1">Trial</span>
                              <span v-else-if="d.textConvert.Journey === 2">Onboarding</span>
                              <span v-else-if="d.textConvert.Journey === 3">Mid</span>
                              <span v-else-if="d.textConvert.Journey === 4">Ongoing</span>
                              <span v-else> - </span>
                            </span>
                          </span>
                          <span v-else-if="!d.isSelect" class="have-height" v-html="d.text"
                                style="font-weight: normal;"></span>
                          <span v-else-if="d.isSelect" v-html="d.text" style="font-weight: normal;"></span>
                          <span v-if="d.businessNoteType === 4">(Normal)</span>
                          <span v-if="d.businessNoteType === 6">(Onboarding)</span>
                          <span v-if="d.businessNoteType === 11">(Churn)</span>
                          <a v-if="d.text.length > 600 && !d.isSelect" @click.prevent="controlHeight(d)">
                            <span>Ver mais</span>
                          </a>
                          <a v-if="d.text.length > 600 && d.isSelect" class="to-hide"
                             @click.prevent="controlHeight(d)">
                            <span><ion-icon name="chevron-up-outline"></ion-icon></span>
                          </a>
                        </p>
                        <p v-on:click="deleteNote(index, d)" class="remove">
                          <i class="fa fa-times" aria-hidden="true"></i>
                        </p>
                        <p @click="fixedNote(index, d)" class="fixed">
                          <img src="../../../../assets/img/fixar.png">
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-if="listTypeToShow === 16">
                    <div v-for="(n, index) in dataNotification" :key="index" class="content-timeline">
                      <div class="timeline-line">
                        <i class="fa fa-bell-o msg" aria-hidden="true"></i>
                      </div>
                      <div class="timeline-align">
                        <div class="timeline-data">
                          <p class="user-note"><span class="date">{{ n.createdAt | formatFullDate24 }}</span></p>
                          <p v-if="n.text" class="text">
                            <span v-html="n.text" style="font-weight: normal"></span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="listTypeToShow === 17">
                    <div v-for="(d, index) in dataTimeline" class="content-timeline">
                      <div class="timeline-line" v-if="d.businessNoteType === 13 || d.businessNoteType === 10">
                        <i v-if="d.businessNoteType === 10" class="fa fa-exclamation-triangle warning"
                           aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 13" class="fa fa-exclamation-circle defaulter"
                           aria-hidden="true"></i>
                        <i v-if="d.businessNoteType === 25" class="fa fa-repeat renovation"
                           aria-hidden="true"></i>
                      </div>
                      <div class="timeline-align">
                        <div class="timeline-data" v-if="d.businessNoteType === 13 || d.businessNoteType === 10"
                             v-bind:class="{'payment-pending': d.businessNoteType === 13}">
                          <p class="user-note">{{ d.userName }}
                            <span class="tag warning" v-if="d.businessNoteType === 10">Financeiro</span>
                            <span class="tag renovation-request" v-if="d.businessNoteType === 25">Renovação</span>
                            <span class="tag warning" v-if="d.businessNoteType === 55">Upsell</span>
                            <span class="tag warning" v-if="d.businessNoteType === 56">Liberação</span>
                          </p>
                          <p v-if="d.businessNoteType === 5" class="user-note">
                            <span class="date">{{ d.createdAt | formatFullDate24 }}</span></p>
                          <p v-if="d.text" class="text">
                            <span v-html="d.text" style="font-weight: normal;"></span>
                            <span v-if="d.businessNoteType === 4">(Normal)</span>
                            <span v-if="d.businessNoteType === 6">(Onboarding)</span>
                            <span v-if="d.businessNoteType === 11">(Churn)</span>
                          </p>
                          <p v-on:click="deleteNote(index, d)" class="remove">
                            <i class="fa fa-times" aria-hidden="true"></i>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="listTypeToShow === 99">
                    <div v-for="(d, index) in dataTimeline" class="content-timeline">
                      <div class="timeline-line" v-if="d.businessNoteType === 99">
                        <i v-if="d.businessNoteType === 99" class="fa fa-paperclip attachment attachment-icon"
                           aria-hidden="true"></i>
                      </div>
                      <div class="timeline-align" v-if="d.businessNoteType === 99">
                        <div class="timeline-data">
                          <p class="user-note">
                            {{ d.userName }}
                            <span class="date">{{ d.createdAt | formatFullDate24 }}</span>
                          </p>
                          <p v-if="d.text" class="text">
                            <span class="text-attachments" v-if="d.businessNoteType === 99">
                              <span v-if="d.text.includes('.pdf')" class="text-attachments-pdf">
                                <span>Arquivo PDF</span>
                                <a :href="d.text" target="_blank">Visualizar</a>
                              </span>
                              <span
                                v-else-if="d.text.includes('.excel') || d.text.includes('.xlsx') || d.text.includes('.csv')"
                                class="text-attachments-excel">
                                <span>Arquivo Excel</span>
                                <a :href="d.text" target="_blank">Visualizar</a>
                              </span>
                              <a
                                v-else-if="d.text.includes('.png') || d.text.includes('.jpeg') || d.text.includes('.svg') || d.text.includes('.webp')"
                                :href="d.text" target="_blank">
                                <img class="text-attachments-img" :src="d.text" alt="Anexo">
                              </a>
                              <span v-else class="text-attachments-other">
                                <span>Anexo</span>
                                <a :href="d.text" target="_blank">Visualizar</a>
                              </span>
                            </span>
                          </p>
                          <p v-on:click="deleteNote(index, d)" class="remove">
                            <i class="fa fa-times" aria-hidden="true"></i>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- footer-menu -->
    <footer-menu v-if="!loadingList"/>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import footerMenu from "../../components/default/footerMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import modalObsFunil from "../../modals/modalObsFunil.vue";
import inputText from "../../components/inputs/inputText.vue";
import modalChangeContactPhoneFunil from "../../modals/modalChangeContactPhoneFunil.vue";
import modalSetActiveFunil from "../../modals/modalSetActiveFunil.vue";
import modalPassword from "../../modals/modalPassword.vue";
import modalOnboarding from "../../modals/modalOnboarding";
import modalChangeOnboarding from "../../modals/modalChangeOnboarding.vue";
import draggable from 'vuedraggable'
import VueTagsInput from '@johmun/vue-tags-input';

import {
  GET_DATA_COMPANY_FUNNEL,
  GET_DATA_COMPANY_NOTF,
  CREATE_ACTIVE_USER,
  CREATE_TAG,
  REMOVE_TAG,
  REMOVE_ACTIVE_USER,
  DELETE_NOTE,
  GET_CHANGE_OWNER_FUNNEL,
  CREATE_NOTE_FUNNEL,
  CREATE_ACTIVE_FUNNEL,
  ADD_COMPANY_NOTES,
  UPLOAD_INFO_PROD,
  UPDATE_FILE_ATTACHMENTS,
  GET_DEFAULT_TAGS_FUNNEL,
  GET_SELECT_RESPONSIBLES,
  CREATE_TAG_FUNNEL,
  CHANGE_DADE_FINANCIAL,
  GET_LINK_CSAT,
  GET_LINK_NPS,
  UPDATE_BUSINESS_TASK_STATUS,
  SEND_EMAIL_CSAT,
  SEND_EMAIL_NPS,
  UPDATE_COMPANY_PROFILE,
  UPDATE_FIXED_NOTE, CHANGE_TICKETS_TICKETS, CHANGE_TICKETS_FILTERS
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import swal from "sweetalert";
import moment from "moment";
import ModalDefault from "../../components/modals/modalDefault.vue";
import InputColor from "../../components/inputs/inputColor.vue";
import BtnSearch from "../../components/buttons/btnSearch.vue";
import InputSelect from "../../components/inputs/inputSelect.vue";
import {MONTHS_NAME} from "../../../../assets/js";
import BtnDefault from "../../components/buttons/btnDefault.vue";
import BtnExcel from "../../components/buttons/btnExcel.vue";
import InputMultiSelectOwn from "../../components/inputs/inputMultiSelectOwn.vue";
import BoxDefault from "../../components/layouts/boxDefault.vue";
import ModalOpenTicket from "../../modals/modalOpenTicket.vue";
import BtnChange from "../../components/buttons/btnChange.vue";
import BtnBlue from "../../components/buttons/btnBlue.vue";
import TooltipDefault from "../../components/tooltip/tooltip-default.vue";

export default {
  name: "detail-company-funnel",
  components: {
    TooltipDefault, BtnBlue, BtnChange,
    ModalOpenTicket,
    BoxDefault,
    InputMultiSelectOwn,
    InputSelect,
    BtnExcel,
    BtnDefault,
    BtnSearch,
    InputColor,
    ModalDefault,
    draggable,
    topMenu,
    footerMenu,
    fullLoading,
    modalChangeContactPhoneFunil,
    modalObsFunil,
    modalSetActiveFunil,
    modalOnboarding,
    modalPassword,
    modalChangeOnboarding,
    inputText,
    VueTagsInput
  },
  data() {
    return {
      title: [],
      respondedBy: [],
      npsScore: [],
      npsType: [],
      comment: [],
      loadingSendingEmail: false,
      emails: [],
      emailToSend: '',
      statusActivities: [
        {
          id: 0,
          name: 'Selecione'
        },
        {
          id: 2,
          name: 'Em andamento'
        },
        {
          id: 3,
          name: 'Concluído'
        }
      ],
      validateStatusActivities: false,
      loadingSendStatusActivities: false,
      selectedNewStatusActivities: '',
      tooltipActivities: {},
      activitieContent: [],
      attachments: '',
      businessNoteTypeFilter: [
        {
          'value': 0,
          'title': 'Intercom'
        },
        {
          'value': 1,
          'title': 'Ligação'
        },
        {
          'value': 2,
          'title': 'Whatsapp'
        },
        {
          'value': 3,
          'title': 'E-Mail'
        },
        {
          'value': 4,
          'title': 'Msg'
        },
        {
          'value': 5,
          'title': 'Retenção'
        },
        {
          'value': 7,
          'title': 'NPS'
        },
        {
          'value': 8,
          'title': 'Sistema'
        },
        // {
        //   'value': 10,
        //   'title': 'Financeiro'
        // },
        {
          'value': 11,
          'title': 'Possível Churn'
        },
        {
          'value': 12,
          'title': 'FollowUp Automatico'
        },
        {
          'value': 14,
          'title': 'Alteração de etapa'
        },
        {
          'value': 6,
          'title': 'Onboarding'
        },
        {
          'value': 18,
          'title': 'Middle'
        },
        {
          'value': 19,
          'title': 'Ongoing'
        },
        {
          'value': 20,
          'title': 'Boas vindas'
        },
        {
          'value': 21,
          'title': 'Treinamento'
        },
        {
          'value': 22,
          'title': 'Parametrização'
        },
        {
          'value': 23,
          'title': 'Despedida'
        },
        {
          'value': 24,
          'title': 'Solicitação cancelamento'
        },
        {
          'value': 26,
          'title': 'Sinalização de contato'
        },
        {
          'value': 27,
          'title': 'Beneflex'
        },
        {
          'value': 28,
          'title': 'Acesso contador'
        },
        {
          'value': 29,
          'title': 'Importação dados de benefício'
        },
        {
          'value': 30,
          'title': 'Atualização fuso horário do turno'
        },
        {
          'value': 31,
          'title': 'Atualização do turno para 24 horas'
        },
        {
          'value': 32,
          'title': 'Escala'
        },
        {
          'value': 33,
          'title': 'MarQTab'
        },
        {
          'value': 34,
          'title': 'Dias duplicados'
        },
        {
          'value': 35,
          'title': 'Sistema'
        },
        {
          'value': 36,
          'title': 'Sistema'
        },
        {
          'value': 39,
          'title': 'NPS Gerado'
        },
        {
          'value': 40,
          'title': 'NPS Respondido'
        },
        {
          'value': 55,
          'title': 'Upsell'
        },
        {
          'value': 56,
          'title': 'Liberação'
        }
      ],
      sendInfoToModal: '',
      listTypeToShow: 15,
      actionEmit: '',
      dataRemoveActive: {},
      actionRemoveActive: '',
      type: "0",
      active: '',
      dataUser: JSON.parse(window.localStorage.getItem('mamUserMasterInfo')),
      loadingList: false,
      loadingSendObs: false,
      loadingTag: false,
      loadingActive: false,
      loadingOwner: false,
      failRequest: false,
      loadingDelTag: false,
      loadingDeleteNote: false,
      loadingSignalContact: false,
      showFiltersSecondary: false,
      owner: [],
      ownerActual: '',
      context: '',
      obs: '',
      tag: '',
      pgTitle: '',
      dataCompany: {
        phone: []
      },
      // dataNps: {
      //   npsColor: '',
      //   npsText: '',
      //   npsTextFull: ''
      // },
      dataNotification: [],
      dataTimeline: [],
      dataTimeLineFixed: [],
      dataLastCSAT: {
        experienceScore: '',
        responseDate: '',
      },
//      dataLastCompanyNps: {
//        rating: '',
//        contactDate: '',
//        responseDate: '',
//      },
      dataTag: [],
      activities: [],
      companyMetrics: {},
      salesObj: {},
      saleInfo: {},
      dataContacts: {},
      dataNotes: '',
      sinalizedContact: '',
      dataPayment: {
        lastPaid: '',
        totalPaid: ''
      },
      sendObjRS: {},
      loadingAttach: false,
      successAttach: false,
      errorAttach: false,
      attachmentValue: '',
      dataTags: '',
      dataSelectResponsibles: '',
      dataSelectResponsiblesFormated: [],
      newTag: {
        name: '',
        color: '',
      },
      dataSelectResponsiblesCsat: ['Selecione'],
      dataSelectResponsiblesNps: ['Selecione'],
      loadingBtnTag: false,
      validateModalTagName: false,
      validateModalTagColor: false,
      dataFinancial: {
        initialMRR: '',
        currentMRR: '',
        revenueListMRR: [],
        companyId: '',
        financialInfo: {
          email: '',
          responsibleName: '',
          secondaryEmails: '',
          street: '',
          number: '',
          neighborhood: '',
          complement: '',
          city: '',
          state: '',
          country: '',
          zipCode: '',
          cnpj: '',
          inscEstadual: '',
          inscMunicipal: '',
          activity: '',
          representationName: '',
        },
      },
      linkGeneratedNPS: true,
      linkGeneratedCSAT: true,
      copied: false,
      copiedNps: false,
      copiedCsat: false,
      statusOnboardingSelect: [
        {
          name: 'Selecione',
          id: ''
        },
        {
          name: 'Onboarding',
          id: '2'
        },
        {
          name: 'Mid',
          id: '3'
        },
        {
          name: 'Ongoing',
          id: '4'
        },
      ],
      statusOnboardingSelected: '',
      validateStatusOnboardingSelected: false,
      validateResponsibleSelected: false,
      loadingLinkCSAT: false,
      loadingLinkNPS: false,
      linkCSAT: '',
      idCSAT: '',
      selectedResponsibleCsat: '',
      loadingLinkNPS: false,
      linkNPS: '',
      lastNpsResult: {},
      lastNpsGenerated: {},
      selectedResponsibleNps: '',
      objToChangeStatusActivie: '',
      ownerActualFormated: '',
      heightMax: '',
      dataTickets: [],
      ticketResponsible: '',
      dataCompanyModal: '',
      listFilters: {},
      companyTier: "",
      valueCurrentProfile: "",
      tooltipOpenned: false,
    }
  },
  methods: {
    valueProfile(value) {
      this.valueCurrentProfile = value;
    },
    setNewProfile() {
      this.tooltipOpenned = false;
      swal({
        title: "Aviso",
        text: "Você tem certeza que deseja executar essa ação na empresa: " + this.dataCompany.name + "\n\n\n Qual motivo?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
        content: {
          element: "div",
          attributes: {
            innerHTML: `<input type="text" id="inputProfileFunil" class="swal-content__input" placeholder="Digite o motivo?">`,
          }
        },
      }).then((value) => {
        const observation = document.querySelector("#inputProfileFunil");
        if (value) {
          if (observation.value) {
            let obj = {
              companyId: this.dataFinancial.companyId,
              companyTier: this.valueCurrentProfile,
              observation: observation.value,
            }

            REQUEST_SERVICE.requestContext('PUT', UPDATE_COMPANY_PROFILE, this.context, obj).then((response) => {
              UTIL_SERVICE.console("RESULT UPDATE_COMPANY_PROFILE", response.data);

              swal("Sucesso", "Perfil alterado com sucesso!", "success").then(() => {
                this.dataInfoCompany();
              })
            }).catch((reason) => {
              swal("Erro", reason.response.data.exceptionMessage
                , "error");
            })
          } else {
            swal("Alerta", "Preencha o motivo para continuar!", "warning");
          }
        }
      })
    },
    orderTickets(value) {
      value.reverse();
      const isLate = value.filter(ticket => ticket.isLate === true && (ticket.stageName !== "Concluído" && ticket.stageName !== "Arquivado"));
      const notDone = value.filter(ticket => ticket.isLate !== true && (ticket.stageName !== "Concluído" && ticket.stageName !== "Arquivado"));
      const newList = new Set([...isLate, ...notDone, ...value]);
      return Array.from(newList);
    },
    openTicket() {
      this.dataCompanyModal = {};
      this.dataCompanyModal.reload = true;
      this.dataCompanyModal.listFilters = this.listFilters;
      this.dataCompanyModal.listFilters.companies = this.dataCompanyModal.listFilters.companies.filter(value => value.id === this.dataCompany.id);
      this.dataCompanyModal.math = Math.floor(Math.random() * 500);

      $("#modalOpenTicket").modal();
    },
    getDashboardFilters() {
      let url = CHANGE_TICKETS_FILTERS;
      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext("GET", url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_TICKETS_FILTERS:", response.data);
          this.listFilters = response.data;

          this.listFilters.responsibles.unshift({id: '', name: 'Selecione'});
          this.listFilters.stages = this.listFilters.stages.filter((value) => value.name !== 'Triagem P');

        })
        .catch((reason) => {
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
    },
    getTickets() {
      let url = CHANGE_TICKETS_TICKETS;

      const date = new Date();
      const end = moment(date).format('YYYY-MM-DD');

      url += "&page=0";
      url += "&rows=999999";
      url += "&hideArchived=true";
      url += "&init=2022-02-16";
      url += "&end=" + end;
      url += "&isLate=false";
      url += "&isDeliver=false";
      url += "&isDeadline=false";
      url += "&deliverSoon=false";
      url += "&useConclusionDate=false";
      url += "&companyId=" + this.dataCompany.id;

      REQUEST_SERVICE.requestContext("GET", url).then((response) => {
        UTIL_SERVICE.console("RESULT CHANGE_TICKETS_TICKETS:", response.data);
        this.dataTickets = response.data;
        this.dataTickets.items = this.dataTickets.items.map(value => {
          const ResponsibleNameFormated = value.responsiblesName.join(', ');
          value.responsiblesName = ResponsibleNameFormated;
          return value;
        });
        this.dataTickets.items = this.orderTickets(this.dataTickets.items);
      }).catch((reason) => {
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    controlHeight(d) {
      if (d.isSelect) {
        d.height = '';
        d.isSelect = false;
      } else {
        d.height = 'max-content';
        d.isSelect = true;
      }
    },
    sendEmailCsat() {
      this.loadingSendingEmail = true;

      let obj = {
        csatId: this.idCSAT,
        emails: [],
      }

      for (let i = 0; i < this.emails.length; i++) {
        const objEmail = this.emails[i];
        const text = objEmail.text;
        obj.emails.push(text);
      }

      REQUEST_SERVICE.requestContext("POST", SEND_EMAIL_CSAT, this.context, obj)
        .then((response) => {
          UTIL_SERVICE.console("RESULT SEND_EMAIL_CSAT:", response.data);

          $("#email-csat").modal('toggle');
          swal("Aviso", response.data, "success");
          this.loadingSendingEmail = false;
        }).catch((reason) => {
        this.loadingSendingEmail = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    openModalSendEmailCsat() {
      $("#email-csat").modal();
    },
    sendEmailNps() {
      if (this.loadingSendingEmail) {
        return;
      }
      this.loadingSendingEmail = true;

      REQUEST_SERVICE.requestContext("POST", `${SEND_EMAIL_NPS}${this.lastNpsGenerated.id}`, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT SEND_EMAIL_NPS:", response);
          swal("Sucesso!", "E-mail enviado com sucesso.", "success");

          this.loadingSendingEmail = false;
        }).catch((reason) => {
        this.loadingSendingEmail = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    sendChangeStatusActivie() {

      if (this.selectedNewStatusActivities) {
        this.objToChangeStatusActivie.businessTaskStatus = this.selectedNewStatusActivities;
      } else {
        return this.validateStatusActivities = true
      }

      this.loadingSendStatusActivities = true;

      REQUEST_SERVICE.put(UPDATE_BUSINESS_TASK_STATUS, this.objToChangeStatusActivie)
        .then((response) => {
          UTIL_SERVICE.console("RESULT UPDATE_BUSINESS_TASK_STATUS:", response.data);
          this.loadingSendStatusActivities = false;
          $("#statusActivities").modal('toggle');
          this.dataInfoCompany();

          swal("Aviso", response.data, "success");
        })
        .catch((reason) => {
          this.loadingSendStatusActivities = false;
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });

    },
    changeStatusActivie(id) {
      this.objToChangeStatusActivie = {
        id: id,
        businessTaskStatus: '',
      }

      $("#statusActivities").modal();
    },
    toggleOpen(value) {
      this.$set(value, 'open', !value.open);
    },
    toggleDropdown(value) {
      this.$set(value, 'showDropdown', !value.showDropdown);
    },
    generateLinkCSAT() {
      this.loadingLinkCSAT = true;

      let obj = {
        companyId: this.dataCompany.id,
      }

      if (this.statusOnboardingSelected) {
        this.validateStatusOnboardingSelected = false;
        obj.journey = this.statusOnboardingSelected
      } else {
        this.loadingLinkCSAT = false;
        return this.validateStatusOnboardingSelected = true;
      }

      if (this.selectedResponsibleCsat && this.selectedResponsibleCsat !== 'Selecione') {
        this.validateResponsibleSelected = false;
        obj.userResponsible = this.selectedResponsibleCsat;
      } else {
        this.loadingLinkCSAT = false;
        return this.validateResponsibleSelected = true;
      }

      REQUEST_SERVICE.requestContext("POST", GET_LINK_CSAT, this.context, obj).then((response) => {
        UTIL_SERVICE.console("RESULT GET_LINK_CSAT:", response.data);

        this.linkCSAT = response.data.link
        this.idCSAT = response.data.csatId
        this.linkGeneratedCSAT = false;
        this.loadingLinkCSAT = false;
      }).catch((reason) => {
        this.loadingLinkCSAT = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    copyLink(link) {
      navigator.clipboard.writeText(link)
      this.copied = true
    },
    copyLinkNps(link) {
      navigator.clipboard.writeText(link)
      this.copiedNps = true
      setTimeout(() => {
        this.copiedNps = false;
      }, 1500);
    },
    copyLinkCsat(link) {
      navigator.clipboard.writeText(link)
      this.copiedCsat = true
      setTimeout(() => {
        this.copiedCsat = false;
      }, 1500);
    },
    generateLinkNPS() {
      this.loadingLinkNPS = true;

      let obj = {
        companyId: this.dataCompany.id,
      }

      if (this.selectedResponsibleNps && this.selectedResponsibleNps !== 'Selecione') {
        this.validateResponsibleSelected = false;
        obj.userResponsible = this.selectedResponsibleNps;
      } else {
        this.loadingLinkNPS = false;
        return this.validateResponsibleSelected = true;
      }

      REQUEST_SERVICE.requestContext("POST", `${GET_LINK_NPS}?companyId=${obj.companyId}&userResponsible=${obj.userResponsible}`, this.context).then((response) => {
        UTIL_SERVICE.console("RESULT GET_LINK_NPS:", response.data);

        this.linkNPS = response.data
        let parts = response.data.split('/');
        let lastPart = parts[parts.length - 1];

        this.lastNpsResult.id = lastPart;
        this.linkGeneratedNPS = false;
        this.loadingLinkNPS = false;
      }).catch((reason) => {
        if (reason.response.data.erros[0].value === 'A empresa já possui um NPS para ser respondido') {
          this.linkGeneratedNPS = false;
          this.loadingLinkNPS = false;
        }
        this.loadingLinkNPS = false;
        swal("Atenção!", reason.response.data.erros[0].value, "error");
      });
    },
    createTag() {
      this.validateModalTagName = false;
      this.validateModalTagColor = false;

      if (this.newTag.name === '')
        return this.validateModalTagName = true;

      if (this.newTag.color === '')
        return this.validateModalTagColor = true;

      this.loadingBtnTag = true;

      REQUEST_SERVICE.post(CREATE_TAG_FUNNEL, this.newTag)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CREATE_TAG_FUNNEL:", response.data);

          swal("Aviso", 'Tag criada com sucesso', "success");
          this.loadingBtnTag = false;
          this.getDataTags();
          $('#createTag').modal('hide');

        }).catch((reason) => {
        this.loadingBtnTag = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    // createTag() {
    //   this.validateModalTagName = false;
    //   this.validateModalTagColor = false;

    //   if (this.newTag.name === '')
    //     return this.validateModalTagName = true;

    //   if (this.newTag.color === '')
    //     return this.validateModalTagColor = true;

    //   this.loadingBtnTag = true;

    //   REQUEST_SERVICE.post(CREATE_TAG_FUNNEL, this.newTag)
    //     .then((response) => {
    //       UTIL_SERVICE.console("RESULT CREATE_TAG_FUNNEL:", response.data);

    //       swal("Aviso", 'Tag criada com sucesso', "success");
    //       this.loadingBtnTag = false;
    //       this.getDataTags();
    //       $('#createTag').modal('hide');

    //     }).catch((reason) => {
    //     this.loadingBtnTag = false;
    //     ALERT_SERVICE.showMsgError(reason.response.data.erros);
    //   });
    // },
    modalCreateTag() {
      $('#createTag').modal();
    },
    clearInput() {
      $("#fileFunel").val(null);
      this.errorAttach = false;
    },
    addAttach(e) {
      this.loadingAttach = false;
      this.successAttach = false;
      this.errorAttach = false;

      this.loadingAttach = true;

      let files = e.target.files;
      let fileAttach = files[0];
      if (!files.length)
        return;

      if (fileAttach.size > 3597152) {
        this.loadingAttach = false;
        this.errorAttach = true;
        return swal("Aviso", "Não foi possivel realizar o envio.\n\n Motivo: arquivo muito grande por favor enviar um arquivo menor que 3.5MB.", "warning");
      }

      UTIL_SERVICE.console("FILE SEND: ", fileAttach);
      REQUEST_SERVICE.fileUpload(UPLOAD_INFO_PROD, fileAttach)
        .then((response) => {
          UTIL_SERVICE.console("RESULT UPLOAD DOCUMENT: ", response);

          this.loadingAttach = false;
          this.attachments = response.data;
          this.successAttach = true

          setTimeout(() => {
            this.createObs(1);
          }, 500)

        }).catch((reason) => {
        swal("Aviso", reason.response.data.erros, "error");
        this.loadingAttach = false;
        this.errorAttach = true
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    addNotes() {
      REQUEST_SERVICE.requestContext("PUT", ADD_COMPANY_NOTES, this.context, {
        notes: this.dataNotes,
        id: this.dataCompany.id,
      })
        .then((response) => {
          UTIL_SERVICE.console("RESULT ADD_COMPANY_NOTES:", response.data);
          this.dataCompany.notes = this.dataNotes;
        })
        .catch((reason) => {
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
    },
    changePhone() {
      this.sendObjRS = {
        company: this.dataCompany,
        contacts: this.dataContacts,
        random: Math.floor(Math.random() * 500)
      };

      $("#modalChangeContactPhoneFunil").modal();
    },
    changeList(list) {
      this.listTypeToShow = list;

      if (this.dataNotification.length === 0 && !this.loadingList) {
        // this.loadingList = true;

        let url = GET_DATA_COMPANY_NOTF;
        url += "?u=" + this.dataUser.id;
        url += "&companyId=" + this.dataCompany.id;
        url += "&contentContext=" + this.dataCompany.contentContext;
        url += "&pipelineId=" + this.$route.params.idPipe;
        url += "&businessId=" + this.$route.params.idBusiness;

        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT GET_DATA_COMPANY_NOTF:", response.data);

          this.dataNotification = response.data;
          this.loadingList = false;
        }).catch((reason) => {
          this.failRequest = true;
          this.loadingList = false;

          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
      }
    },
    setActive() {
      $("#modalSetActiveFunil").modal();
    },
    confirmRemove(data, index) {
      this.dataRemoveActive.data = data;
      this.dataRemoveActive.index = index;

      $("#password-modal").modal();
    },
    removeActive(password) {
      const passwordCsat = 'equipeCS@2023';

      if (password === passwordCsat) {
        let url = REMOVE_ACTIVE_USER;

        url += "?id=" + this.dataRemoveActive.data.id;
        url += "&u=" + this.dataUser.id;
        url += "&pipelineId=" + this.$route.params.idPipe;
        url += "&pipelineBusinessId=" + this.$route.params.idBusiness;

        UTIL_SERVICE.console("Data send: ", url);
        REQUEST_SERVICE.get(url).then((response) => {

          swal("Aviso", response.data, "success");
          this.dataInfoCompany();

        }).catch((reason) => {
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
      } else {
        swal("Aviso", 'Senha incorreta!', "error");
      }
    },
    deleteNote(index, data) {

      swal({
        title: "Aviso!",
        text: "Tem certeza que deseja excluir esta nota do funil?",
        icon: "warning",
        buttons: {
          cancel: "Cancelar",
          catch: {
            text: "Confirmar",
            value: "confirm",
          }
        },
      })
        .then((value) => {
          switch (value) {
            case "confirm":
              if (!this.loadingDeleteNote) {
                this.loadingDeleteNote = true;
                let url = DELETE_NOTE;
                url += "?businessNoteId=" + data.id;
                url += "&u=" + this.dataUser.id;

                REQUEST_SERVICE.get(url).then((response) => {
                  this.loadingDeleteNote = false;
                  this.dataTimeline.splice(index, 1);

                  swal("Aviso", response.data, "success");
                }).catch((reason) => {
                  this.loadingDeleteNote = false;

                  ALERT_SERVICE.showMsgError(reason.response.data.erros);
                });
              }
              break;

            default:
              swal("Cancelado!", {
                icon: "error",
              });
          }
        });
    },
    fixedNote(index, d) {
      let url = UPDATE_FIXED_NOTE;
      url += "?businessNoteId=" + d.id;
      url += "&isFixed=" + !d.isFixed;

      REQUEST_SERVICE.get(url).then(response => {
        UTIL_SERVICE.console("RESULT UPDATE_FIXED_NOTE", response.data);
        this.dataInfoCompany();
      }).catch((reason) => {
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      })
    },
    deleteCompanyTag(index, data) {
      if (!this.loadingDelTag) {
        this.loadingDelTag = true;
        UTIL_SERVICE.console("Data send: ", data);
        REQUEST_SERVICE.post(REMOVE_TAG, data).then((response) => {
          UTIL_SERVICE.console("RESULT REMOVE_TAG:", response.data);

          this.loadingDelTag = false;

          this.dataTag.splice(index, 1);

          swal("Aviso", response.data, "success");
        }).catch((reason) => {
          this.loadingDelTag = false;

          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
      }
    },
    buttonTools() {
      this.changeInfos(true);
      this.saveInfo(true);
      this.hiddenEdit(false);
    },
    saveAlert() {
      this.buttonTools();
      this.addNotes();
      swal("Sucesso!", "Editado com êxito!", "success");
    },
    cancelAlert() {
      this.buttonTools();
      this.dataNotes = this.dataCompany.notes;
      swal("Cancelado!", "Cancelado com êxito!", "error");
    },
    editText() {
      this.changeInfos(false);
      this.saveInfo(false);
      this.hiddenEdit(true)
    },
    addTag(name, color) {
      if (!this.loadingTag) {

        this.loadingTag = true;
        let obj = {
          userId: this.dataUser.id,
          pipelineId: this.$route.params.idPipe,
          pipelineBusinessId: this.$route.params.idBusiness,
          value: name,
          color: color
        };

        UTIL_SERVICE.console("Data send: ", obj);
        REQUEST_SERVICE.post(CREATE_TAG, obj).then((response) => {
          UTIL_SERVICE.console("RESULT CREATE_TAG:", response.data);

          swal("Aviso", response.data, "success");
          this.loadingTag = false;
          this.dataInfoCompany();
        }).catch((reason) => {
          this.loadingTag = false;
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
      }
    },
    // AQUI CRIAÇÃO DE NOTE
    createObs(type) {
      let txt = ''
      let txtSend = ''

      if (type === 0) {
        txt = document.getElementById('txtarea').value;
        txtSend = txt.replaceAll("\n", "<br>")
      }

      if (type === 1) {
        txtSend = this.attachments
      }

      this.loadingSendObs = true;

      let obj = {
        userId: this.dataUser.id,
        userName: this.dataUser.name,
        pipelineId: this.$route.params.idPipe,
        pipelineBusinessId: this.$route.params.idBusiness,
        businessNoteType: this.type,
        text: txtSend
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.post(CREATE_NOTE_FUNNEL, obj).then((response) => {
        UTIL_SERVICE.console("RESULT CREATE_NOTE_FUNNEL:", response.data);

        swal("Aviso!", "Adicionado a timeline com sucesso.", "success");

        this.obs = "";
        this.loadingSendObs = false;
        this.attachments = '';
        this.dataInfoCompany();

      }).catch((reason) => {
        this.failRequest = true;
        this.loadingSendObs = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    statusOnboarding() {
      $("#changeOnboardingModal").modal();
    },
    createActive(value, response) {
      if (value) {
        this.active = value;

        $("#modalObsFunil").modal();
      } else {
        if (!this.loadingActive) {
          this.loadingActive = true;
          this.loadingList = true;
          let obj = {
            userId: this.dataUser.id,
            userName: this.dataUser.name,
            pipelineId: this.$route.params.idPipe,
            pipelineBusinessId: this.$route.params.idBusiness,
            businessNoteType: this.active,
            text: response.value
          };

          UTIL_SERVICE.console("Data send: ", obj);
          REQUEST_SERVICE.post(CREATE_ACTIVE_FUNNEL, obj).then((response) => {
            UTIL_SERVICE.console("RESULT CREATE_ACTIVE_FUNNEL:", response.data);

            swal("Aviso", response.data, "success");
            this.loadingActive = false;
            this.dataInfoCompany();
          }).catch((reason) => {
            this.loadingActive = false;
            this.loadingList = false;
            ALERT_SERVICE.showMsgError(reason.response.data.erros);
          });
        }
      }
    },
    dataInfoCompany() {
      this.loadingAttach = false;
      this.successAttach = false;
      this.errorAttach = false;
      this.loadingList = true;

      let url = GET_DATA_COMPANY_FUNNEL;
      url += "?u=" + this.dataUser.id;
      url += "&pipelineId=" + this.$route.params.idPipe;
      url += "&businessId=" + this.$route.params.idBusiness;

      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT GET_DATA_COMPANY_FUNNEL:", response.data);

        // this.dataNps = {
        //   npsColor: response.data.npsColor,
        //   npsText: response.data.npsText,
        //   npsTextFull: response.data.npsTextFull
        // };
        this.lastNpsResult = response.data.lastNPS;
        if (response.data.lastNPSGenerated) this.lastNpsGenerated = response.data.lastNPSGenerated;
        this.dataCompany = response.data.company;
        // inserir no dataTimeline as info do
        this.dataTimeline = response.data.timeline;
        this.dataTag = response.data.tags;
        this.ownerActual = response.data.ownerName;
        this.activities = response.data.activities;
        this.dataContacts = response.data.contacts;
        this.companyMetrics = response.data.companyMetrics;
        this.saleInfo = response.data.saleInfo;
        this.salesObj = response.data.salesObj;
        this.dataNotes = response.data.company.notes;
        this.sinalizedContact = response.data.sinalizedContact;
        this.companyTier = response.data.companyTier;
        this.valueCurrentProfile = response.data.companyTier;

        this.dataTimeLineFixed = this.dataTimeline.filter(items => items.isFixed == true);
        this.dataTimeLineFixed = this.dataTimeLineFixed.map(value => {
          let obj = {...value, isSelect: false, height: ''};
          if (obj.text.length < 600) {
            obj.height = "max-content";
          }

          return obj;
        })

        this.dataTimeline = this.dataTimeline.map(value => {
          let obj = {...value, isSelect: false, height: ''};
          if (obj.text.length < 600) {
            obj.height = "max-content";
          }
          return obj;
        })

        if (response.data.owners.length) {
          this.ownerActualFormated = response.data.owners.join(', ')

          if (!this.ownerActual) {
            this.ownerActual = this.ownerActualFormated
          }
        }

        if (response.data.lastCsat) {
          this.dataLastCSAT = response.data.lastCsat;
        }

        if (response.data.lastCompanyNps) {
          this.dataLastCompanyNps = response.data.lastCompanyNps;
        }

        try {
          this.dataTimeline.map((v) => {
            if (v.businessNoteType === 39) {
              const parser = new DOMParser();
              let doc = parser.parseFromString(v.text, 'text/html');
              this.title.push(doc.querySelector('b').innerText);
            }
            if (v.businessNoteType === 40) {
              const parser = new DOMParser();
              let doc = parser.parseFromString(v.text, 'text/html');
              this.title.push(doc.querySelector('p b').innerText);

              this.respondedBy.push(doc.querySelectorAll('p')[1].innerText);

              let npsText = doc.querySelectorAll('p')[2].innerText;
              let npsMatch = npsText.match(/Nota do NPS:\s*(\d+)\s*-\s*(\w+)/);
              if (npsMatch) {
                this.npsScore.push(npsMatch[1]);
                this.npsType.push(npsMatch[2]);
              }

              let commentText = doc.querySelectorAll('p')[3].innerText;
              let commentMatch = commentText.match(/Comentário:\s*(.*)/);
              if (commentMatch) {
                this.comment.push(commentMatch[1])
              }
            }
            if (v.businessNoteType === 88) {
              v.textConvert = JSON.parse(v.text);
            }
            if (v.businessNoteType === 89) {
              v.textConvert = JSON.parse(v.text);
            }
          });
        } catch (e) {
          console.log(e)
        }

        this.context = this.dataCompany.contentContext

        if (response.data.companyPayments)
          this.dataPayment = response.data.companyPayments;

        this.loadingList = false;

        this.getDataFinancial();
        this.getTickets();
        this.parseResponse();

      }).catch((reason) => {
        this.failRequest = true;
        this.loadingList = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    parseResponse() {
    },
    getDataTags() {
      REQUEST_SERVICE.get(GET_DEFAULT_TAGS_FUNNEL).then((response) => {
        UTIL_SERVICE.console("RESULT GET_DEFAULT_TAGS_FUNNEL:", response.data);

        this.dataTags = response.data
      }).catch((reason) => {
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    getDataFinancial() {
      this.loadingList = true;
      const url = CHANGE_DADE_FINANCIAL + "?i=" + this.dataCompany.id;

      REQUEST_SERVICE.requestContext("GET", url, this.dataCompany.contentContext)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_DADE_FINANCIAL:", response.data);

          this.dataFinancial = response.data;
          this.loadingList = false
        })
        .catch((reason) => {
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
          this.loadingList = false
        });
    },
    getSelectResponsibles() {
      REQUEST_SERVICE.get(GET_SELECT_RESPONSIBLES).then((response) => {
        UTIL_SERVICE.console("RESULT GET_SELECT_RESPONSIBLES:", response.data);

        this.dataSelectResponsibles = response.data

        this.dataSelectResponsibles.map((value) => {
          this.dataSelectResponsiblesFormated.push(
            {
              name: value,
              id: value
            }
          )
        })

        this.dataSelectResponsiblesCsat.push(...response.data)
        this.dataSelectResponsiblesNps.push(...response.data)
      }).catch((reason) => {
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    setOwner() {
      this.loadingOwner = true;

      if (this.ownerActual && this.owner.length) {
        const ownerActualArray = this.ownerActual.split(", ");
        for (let i = 0; i < ownerActualArray.length; i++) {
          if (!this.owner.includes(ownerActualArray[i])) {
            this.owner.push(ownerActualArray[i]);
          }
        }
      }

      let obj = {
        u: this.dataUser.id,
        pipelineId: this.$route.params.idPipe,
        businessId: this.$route.params.idBusiness,
        names: this.owner
      };

      REQUEST_SERVICE.post(GET_CHANGE_OWNER_FUNNEL, obj).then((response) => {
        UTIL_SERVICE.console("RESULT GET_CHANGE_OWNER_FUNNEL:", response.data);

        this.loadingOwner = false;
        this.owner = [];
        location.reload()
      }).catch((reason) => {
        this.loadingOwner = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    changeInfos: function toggle(enable) {
      document.getElementById("important-infos").disabled = enable;
    },
    saveInfo: function toggle(hidden) {
      document.getElementById("change-info-cancel").hidden = hidden;
      document.getElementById("change-info-save").hidden = hidden;
    },
    hiddenEdit: function toggle(change) {
      document.getElementById("change-edit-info").hidden = change;
    },
    changeBoxFilters(type) {
      this.showFiltersSecondary = !this.showFiltersSecondary

      if (type === 2) {
        if (this.listTypeToShow === 16 || this.listTypeToShow === 17) {
          return
        } else {
          this.changeList(15)
        }
      }
    },
    signalContact() {
      const typeSignalObs = 26;
      const date = new Date();
      const day = moment(String(date)).format('DD/MM/YYYY')
      const hour = moment(String(date)).format('HH:mm')

      const textSignalObs = "Sinalizou contato em " + day + " às " + hour

      swal({
        title: "Aviso!",
        text: "Sinalizar ultimo contato?",
        icon: "warning",
        buttons: {
          cancel: "Cancelar",
          catch: {
            text: "Confirmar",
            value: "confirm",
          }
        },
      })
        .then((response) => {
          switch (response) {
            case "confirm":
              this.loadingSignalContact = true;
              this.createNewNote(typeSignalObs, textSignalObs)
              break;

            default:
              swal("Cancelado!", '', "error");
          }
        })
    },
    createNewNote(type, str) {
      let obj = {
        userId: this.dataUser.id,
        userName: this.dataUser.name,
        pipelineId: this.$route.params.idPipe,
        pipelineBusinessId: this.$route.params.idBusiness,
        businessNoteType: type,
        text: str
      };

      REQUEST_SERVICE.post(CREATE_NOTE_FUNNEL, obj)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CREATE_NOTE_FUNNEL:", response.data);

          this.dataInfoCompany();
        }).catch((reason) => {
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    downloadExcel() {
      let bodyValue = [];
      let headValue = ["Ano", "Mês", "Valor MRR", "Motivo de Alteração", "Funcionários", 'MRR Inicial ' + this.dataFinancial.initialMRR, 'MRR Atual ' + this.dataFinancial.currentMRR];
      const monthNames = MONTHS_NAME;

      Object.entries(this.dataFinancial.revenueListMRR).forEach(([year, yearData]) => {
        yearData.forEach((data) => {
          let totalEmployee = '';
          if (data.changeMotive.indexOf('19') > -1) {
            totalEmployee = 19;
          } else if (data.changeMotive.indexOf('8') > -1) {
            totalEmployee = 8;
          } else if (data.changeMotive.indexOf('177') > -1) {
            totalEmployee = 177;
          }
          let monthName = monthNames[data.month - 1];
          bodyValue.push([year, monthName, data.mrrValue, data.changeMotive, totalEmployee]);
        });
      });
      window.downloadListExcel(headValue, bodyValue, "Lista de MRR");
    },
  },
  watch: {
    actionEmit: function (response) {
      this.createActive('', response);
    },
    actionRemoveActive: function (response) {
      this.dataRemoveActive.data.comments = response.comments;
      this.dataRemoveActive.data.isDone = response.isDone;

      if (response.isDone)
        this.removeActive();
    },
    statusOnboardingSelected: function (newValue, oldValue) {
      this.linkGeneratedCSAT = true;
    }
  },
  beforeMount() {
    this.dataInfoCompany();
    this.getDataTags();
    this.getSelectResponsibles();
    this.getDashboardFilters();
  }
}
</script>

<style lang="scss">

.company-profile {
  padding: 0 14px 0 0;

  .button {
    .button__change {
      .button__content {
        font-size: 17px;
      }
    }
  }
}

.tooltip-body {
  padding: 30px 0 0 5px;

  .body-status {
    display: flex;
    margin-bottom: 10px;
    position: relative;

    .btn-change-plan {
      position: absolute;
      bottom: -10px;
      right: 0;
    }

    .content-input {
      display: flex;
      flex-direction: column;

      input {
        border: none;
        -webkit-appearance: none;
        display: block;
        margin: 0 0 11px 0;
        width: 30px;
        height: 30px;
        border-radius: 50% !important;
        cursor: pointer;
        vertical-align: middle;
        box-shadow: rgba(126, 141, 167, 0.5) 0 1px 1px, inset rgba(126, 141, 167, 0.5) 0 0 0 1px;
        background-color: var(--classic-white);
        background-image: -webkit-radial-gradient(var(--high-blue) 0%, var(--high-blue) 33%, var(--classic-white) 40%, var(--classic-white) 70%);
        background-repeat: no-repeat;
        -webkit-transition: background-position .15s cubic-bezier(.8, 0, 1, 1),
        -webkit-transform .25s cubic-bezier(.8, 0, 1, 1);
        outline: none;
      }

      input:checked {
        -webkit-transition: background-position .2s .15s cubic-bezier(0, 0, .2, 1),
        -webkit-transform .25s cubic-bezier(0, 0, .2, 1);
      }

      input:disabled {
        background-color: var(--classic-gray);
        cursor: no-drop;
      }

      input:active {
        -webkit-transform: scale(1.5);
        -webkit-transition: -webkit-transform .1s cubic-bezier(0, 0, .2, 1);
      }


      /* The up/down direction logic */

      input,
      input:active {
        background-position: 0 24px;
      }

      input:checked {
        background-position: 0 0;
      }

      input:checked ~ input,
      input:checked ~ input:active {
        background-position: 0 -24px;
      }
    }

    .content-span {
      display: flex;
      flex-direction: column;

      span {
        font-size: 13px;
        font-weight: 400;
        text-decoration: underline;
      }

      .span-trial {
        margin: 6px 0 10px 25px;
      }

      .span-onboarding {
        margin: 12px 0 10px 25px;
      }

      .span-mid {
        margin: 13px 0 10px 25px;
      }

      .span-ongoing {
        margin: 13px 0 10px 25px;
      }
    }
  }

  .btn-change {
    position: absolute;
    bottom: 20px;
    right: 30px;
    text-decoration: none;
    background: var(--high-blue);
    padding: 9px 30px;
    color: var(--classic-white);
    border-radius: 4px !important;

    &:hover {
      background: #20179E;
    }
  }
}

.bg-fixed {
  border: .5px solid red;
  overflow: hidden;
}

.heightMax {
  max-height: max-content;
}

.csat-email {
  .vue-tags-input {
    width: 100%;
    max-width: 100%;
    margin-bottom: 15px;
    padding: 0 15px;

    .ti-input {
      background: #EEF2F7;
      border-radius: 4px !important;
      padding: 6px 12px;
      border: 1px solid #EEF2F7;
      transition: .2s;
      font-size: 16px;
      font-weight: 400;
      color: var(--dark-gray);

      .ti-tags {

        .ti-tag {
          background: #2F23D6;
          color: #FFFFFF;
          border-radius: 4px !important;
          border: none;
        }

        .ti-new-tag-input-wrapper {

          input {
            color: var(--dark-gray);
            font-size: 16px;
            background: #EEF2F7;

            &::placeholder {
              color: var(--dark-gray);
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}

.search {
  &__responsible {
    label {
      margin-bottom: 8px;
    }

    b {
      margin-top: 10px;
      font-size: 21px;
      color: #191919;

    }
  }

  &__required {
    font-weight: 400;
    font-size: 14px;
    color: #191919;
    margin-bottom: 25px;
  }

  &__generate > &__btn {
    span {
      display: flex;
      align-items: center;
      width: max-content;
      font-weight: 400;
      font-size: 14px;
      color: #2F23D6;
      padding: 10px 20px;
      border: 1px solid #2F23D6;
      border-radius: 4px !important;
      transition: .2s;
      cursor: pointer;

      &:hover {
        background: #2F23D6;
        color: #FFFFFF;

        .button-loading {
          .button-spinner {
            > div {
              background-color: #FFFFFF;
            }
          }
        }
      }

      ion-icon {
        font-size: 20px;
        margin-right: 6px;
      }

      .button-loading {
        .button-spinner {
          > div {
            margin-top: 3px;
            background-color: #2F23D6;
          }
        }
      }
    }
  }

  &__generate {
    display: flex;
    justify-content: space-between;
  }

  &__generate > &__generated {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  &__generate > &__generated > &__generated__btn {
    display: flex;
    align-items: center;
    width: max-content;
    font-weight: 400;
    font-size: 14px;
    color: #2ACC6B;
    padding: 10px 20px;
    border: 1px solid #2ACC6B;
    border-radius: 4px !important;
    transition: .2s;
    cursor: pointer;

    ion-icon {
      font-size: 20px;
      margin-right: 6px;
    }
  }

  &__generate > &__generated > &__generated__link {
    font-weight: 400;
    font-size: 14px;
    color: #7F8897;
    margin-top: 10px;
    margin-bottom: 4px;
  }

  &__generate > &__generated > &__generated__copy {
    display: flex;
    align-items: center;
    width: max-content;
    font-weight: 400;
    font-size: 14px;
    color: #2F23D6;
    transition: .2s;
    cursor: pointer;
    border-bottom: 1px solid transparent;

    &:hover {
      color: #352DA5;
      border-bottom: 1px solid #352DA5;
    }

    ion-icon {
      font-size: 20px;
      margin-right: 6px;
    }
  }

  &__generate > &__generated > &__generated__copied {
    position: absolute;
    bottom: 1.5px;
    left: 110px;
    font-size: 11px;
    color: #FF445D;
  }
}

.default-box {
  background-color: #FFFFFF;
  padding: 20px;
  margin-bottom: 25px;
  border-radius: 10px !important;
  box-shadow: none;
}

.attendance {

  &__csat > &__title {
    font-weight: 400;
    font-size: 21px;
    color: #191919;
    margin: 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #E6E9EC;

    ion-icon {
      font-size: 20px;
      color: #2F23D6;
      cursor: pointer;
      transition: .2s;

      &:hover {
        color: #352DA5;
      }
    }
  }

  &__csat > &__body {
    display: flex;
    align-items: flex-start;
    margin-top: 10px;

    img {
      width: 48px;
      height: 53px;
      background: green;
      padding: 6.5px 4px;
      border-radius: 4px !important;
      margin-right: 7px;
    }
  }

  &__csat > &__body > &__content {
    display: flex;
    flex-direction: column;

    span {
      font-weight: 400;
      font-size: 12px;
      color: #7F8897;
      line-height: 130%;
    }
  }

  &__csat > &__body > &__content > &__status {
    font-weight: 400;
    font-size: 18px;
    color: #191919;
  }

  &__csat > &__link {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    color: #2F23D6;
    margin-top: 7px;
    width: max-content;
    border-bottom: 1px solid transparent;
    transition: .2s;
    cursor: pointer;

    &:hover {
      border-bottom: 1px solid #352DA5;
      color: #352DA5;
    }

    ion-icon {
      font-size: 17px;
      color: #2F23D6;
      margin-right: 4px;
    }
  }

  &__nps > &__link {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    color: #2F23D6;
    margin-top: 7px;
    width: max-content;
    border-bottom: 1px solid transparent;
    transition: .2s;
    cursor: pointer;

    &:hover {
      border-bottom: 1px solid #352DA5;
      color: #352DA5;
    }

    ion-icon {
      font-size: 17px;
      color: #2F23D6;
      margin-right: 4px;
    }
  }


  &__nps > &__title {
    font-weight: 400;
    font-size: 21px;
    color: #191919;
    margin: 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #E6E9EC;

    ion-icon {
      font-size: 20px;
      color: #2F23D6;
      cursor: pointer;
      transition: .2s;

      &:hover {
        color: #352DA5;
      }
    }
  }

  &__nps > &__body {
    display: flex;
    align-items: flex-start;
    margin-top: 10px;

    img {
      width: 48px;
      height: 53px;
      background: green;
      padding: 6.5px 4px;
      border-radius: 4px !important;
      margin-right: 7px;
    }
  }

  &__nps > &__body > &__note {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 53px;
    width: 39px;
    font-size: 32px;
    font-weight: 700;
    color: #FFFFFF;
    background: green;
    padding: 9px 4px;
    border-radius: 4px !important;
    margin-right: 7px;
  }

  &__nps > &__body > &__content {
    display: flex;
    flex-direction: column;

    span {
      font-weight: 400;
      font-size: 12px;
      color: #7F8897;
      line-height: 130%;
    }
  }

  &__nps > &__body > &__content > &__status {
    font-weight: 400;
    font-size: 18px;
    color: #191919;
  }
}

.h5t {
  max-width: 95%;

  ion-icon {
    position: absolute;
    right: 20px;
    font-size: 40px;
    cursor: pointer;
    color: #A3A8AD;
  }

  span {
    margin: 5px 5px 0 0 !important;
    display: inline-block;
    border: 1px solid #A3A8AD;
    color: #A3A8AD;
    padding: 8px 10px;
    border-radius: 4px !important;
    cursor: pointer;
  }

  .span-all {
    margin-right: 0 !important;
  }

  .span-financial {
    margin-right: 0 !important;
  }

  .span-notifications {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .active-title {
    border: 1px solid #333;
    color: #333;
  }
}

.label-span {
  display: block;

  span {
    font-size: 12px;
    display: inline-block;
  }
}

.all-tags {
  .default {
    background: #898C8E;
  }

  .system {
    background: #898C8E;
  }

  .wts {
    background: #25D366;
  }

  .jivo {
    background: #6C7C93;
  }

  .onboarding {
    background: #2DB2C7;
  }

  .email {
    background: #3598DC;
  }

  .nps {
    background: #283DA7;
  }

  .note,
  .phone {
    background: #17066D;
  }

  .msg {
    background: #114A7F;
  }

  .warning {
    font-size: 19px;
    background: #F19D22;
  }

  .onbording {
    background: #0E600C;
  }

  .pchurn {
    background: #F45252;
    padding: 16px 12px;
  }

  .magic {
    background: #FF5531;
    padding: 16px 12px;
  }

  .refresh {
    background: var(--high-blue);
    padding: 16px 12px;
  }

  .defaulter {
    background: var(--light-orange);
    padding: 16px 12px;
  }

  .renovation {
    background: #EF856C;
    padding: 16px 12px;
  }

  .onboarding-trainee {
    background: var(--light-violet);
    padding: 16px 12px;
  }

  .middle {
    background: #FF9999;
    padding: 16px 12px;
  }

  .ongoing {
    background: #52C977;
    padding: 16px 12px;
  }

  .welcome {
    background: #37C8AE;
    padding: 16px 12px;
  }

  .trainee {
    background: #1E22AA;
    padding: 16px 12px;
  }

  .parameter {
    background: #7F8897;
    padding: 16px 12px;
  }

  .farewell {
    background: #FF0000;
    padding: 16px 12px;
  }

  .cancellation-request {
    background: #FFC277;
    padding: 16px 12px;
  }

  .renovation-request {
    background: #EF856C;
    padding: 16px 12px;
  }

  .contact-signal {
    background: #FF3707;
    padding: 16px 12px;
  }

  .contact-signal-icon {
    font-size: 19.3px !important;
  }

  .status-csat {
    background: #2ACC6B;
    padding: 2px 4px;
  }

  .attachment {
    background: #89A194;
    padding: 16px 12px;
  }
}

.box-tickets {
  .isLate {
    background: #FF5050;
    color: #fff;

    a {
      color: #fff !important;
    }
  }

  .done {
    background: #e6e9ec;
    color: #5B5B5B;

    a {
      color: #5B5B5B;
    }
  }

  h5 {
    color: #333;
    padding-bottom: 10px;
    border-bottom: 1px solid #BBBEC0;
    font-size: 21px;
    margin-bottom: 20px;
    margin-top: 0;
  }

  .btn-new-ticket {
    position: absolute;
    top: 16px;
    right: 20px;
    border: none;
    border-radius: 4px !important;
    background: #3598DC;
    padding: 4px 8px;
    color: #fff;

    &:hover {
      background: #054F91;
    }
  }

  ul {
    padding: 1px;
    background: #fff;
    max-height: 324px;
    overflow-y: scroll;

    li {
      display: flex;
      flex-direction: column;
      list-style: none;
      padding: 6px 12px;
      background: #fff;
      margin: 0 4px 8px 0;
      border-radius: 5px !important;
      box-shadow: 0 0 4px rgba(0, 0, 0, .25);
      position: relative;

      a {
        margin: 0;
        color: #337AB7;
        font-weight: 600;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      p {
        margin: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        span {
          font-weight: 600;
        }

        &:last-child {
          position: absolute;
          bottom: 7px;
          right: 12px;
          font-size: 12px;
          float: left;

          @media only screen and (max-width: 1466px) {
            position: initial;
          }
        }
      }
    }
  }
}

.box-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;

  div {
    display: flex;
    flex-direction: column;

    a {
      width: 100%;
      text-align: center;
      font-weight: 600;
      text-decoration: none;
      border: 1px solid #337AB7;
      padding: 2px 4px;
      border-radius: 4px !important;
      margin: 4px 2px;
    }
  }
}

.box-company-detail-f {
  .nps-text-info {
    width: 100%;
    margin: 0 0 20px;
    padding: 5px 0;
    text-align: center;
    font-size: 16px;
    color: #FFF;
    font-weight: 600;
    border-radius: 4px !important;
  }

  h5 {
    color: #333;
    padding-bottom: 10px;
    border-bottom: 1px solid #BBBEC0;
    font-size: 21px;
    margin-bottom: 30px;
    margin-top: 0;

    span {
      font-size: 13px;

      a {
        position: absolute;
        left: 21px;
        top: 58px;

        &:hover {
          border-bottom: 1px dashed;
          text-decoration: none;
        }
      }
    }

    &:last-of-type {
      margin-top: 40px;
      margin-bottom: 20px;
    }
  }

  p {
    margin: 0 0 10px;

    span {
      font-weight: 600;
      float: right;
    }
  }

  .box-tag {
    position: relative;
    display: block;

    .tag {
      background: #97999B;
      color: #FFF;
      padding: 6px 10px;
      border-radius: 4px !important;
      font-size: 12px;
      display: inline-block;
      margin-right: 10px;
      margin-top: 0;
      margin-bottom: 20px;

      i {
        cursor: pointer;
        float: right;
        margin-top: 2px;
        padding-left: 10px;
      }
    }
  }
}

.box-metrics {
  h5 {
    color: #333;
    padding-bottom: 10px;
    border-bottom: 1px solid #BBBEC0;
    font-size: 21px;
    margin-bottom: 20px;
    margin-top: 0;
  }

  p {
    span {
      float: right;
      font-weight: 600;
    }
  }
}

.box-activities {
  h5 {
    color: #333;
    padding-bottom: 10px;
    border-bottom: 1px solid #BBBEC0;
    font-size: 21px;
    margin-bottom: 20px;
    margin-top: 0;

    span {
      text-transform: uppercase;
    }
  }

  .active {
    margin: 0 0 15px 0;
    padding: 10px;
    background: #FFFFFF;
    box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.25);
    border-radius: 4px !important;

    .active-header {
      display: flex;
      justify-content: space-between;

      .header-title {
        .title {
          font-weight: 700;
          font-size: 14px;
          color: #191919;
          display: flex;

          ion-icon {
            margin-left: 4px;
          }
        }
      }

      ion-icon {
        font-size: 20px;
        cursor: pointer;
      }
    }

    .active-body {
      display: flex;
      flex-direction: column;
      position: relative;

      .body-date {
        font-weight: 400;
        font-size: 11px;
        color: #3A424E;
      }

      .body-status {
        font-weight: 600;
        font-size: 11px;
        color: #3A424E;
        display: flex;
        gap: 1%;
        line-height: 16px;

        ion-icon {
          font-size: 16px;
          pointer-events: none;
        }
      }

      .body-responsible {
        font-weight: 600;
        font-size: 14px;
        color: #2F23D6;
      }

      .body-obs {
        margin-top: 5px;
        padding-top: 5px;
        border-top: 1px solid #E6E9EC;
        font-weight: 600;
        font-size: 11px;
        color: #3A424E;
      }

      .body-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 0;
        top: 28px;
        padding: 0;
        height: 24px;
        border: none;
        border-radius: 4px !important;
        background: #2F23D6;
        width: 34px;
        cursor: pointer;

        ion-icon {
          color: #FFFFFF;
          font-size: 20px;
          pointer-events: none;
        }

        .listdrop {
          position: absolute;
          top: 0;
          left: 35px;
          list-style: none;
          padding: 0;
          width: max-content;
          z-index: 1;
          border-radius: 4px !important;
          color: #2F23D6;
          box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.25);
          background: #FFFFFF;
          transition: .2s;

          li {
            border-top-left-radius: 4px !important;
            border-top-right-radius: 4px !important;
            padding: 5px 15px;
            font-weight: 600;
            transition: .2s;

            &:hover {
              background: #2F23D6;
              color: #FFFFFF;
            }
          }

          .listdrop-delete {
            color: var(--light-red);
            border-top-left-radius: 0 !important;
            border-top-right-radius: 0 !important;
            border-bottom-left-radius: 4px !important;
            border-bottom-right-radius: 4px !important;

            &:hover {
              background: var(--light-red);
              color: #FFFFFF;
            }
          }
        }
      }
    }
  }

  .btn-add-active {
    display: block;
    border-radius: 4px !important;
    background-color: #3598DC;
    height: 33px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    position: relative;
    width: auto;
    padding: 0 20px;
    margin-top: 20px;

    &:hover {
      background-color: #054F91;
    }
  }
}

.box-owner {
  h5 {
    color: #333;
    padding-bottom: 10px;
    border-bottom: 1px solid #BBBEC0;
    font-size: 21px;
    margin-bottom: 20px;
    margin-top: 0;

    span {
      text-transform: uppercase;
    }
  }

  label {
    display: block;
  }

  .input-multiselect {
    padding: 0;
  }

  .btn-send-owner {
    float: right;
    margin-top: 10px;
    border-radius: 4px !important;
    background-color: #3598DC;
    height: 33px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    position: relative;
    width: auto;
    padding: 0 20px;

    &:hover {
      background-color: #054F91;
    }
  }
}

.box-create-tag {

  h5 {
    color: #333;
    padding-bottom: 10px;
    border-bottom: 1px solid #BBBEC0;
    font-size: 21px;
    margin-bottom: 20px;
    margin-top: 0;

    span {
      float: right;
      margin-top: -10px;
      color: #FFFFFF;
      font-size: 14px;
      font-weight: 400;
      padding: 9px 16px;
      background: #2F23D6;
      border-radius: 4px !important;
      cursor: pointer;
      transition: .2s;

      &:hover, &:active {
        background: #352DA5;
      }
    }
  }

  .box-tag {
    position: relative;
    display: block;

    .tag {
      cursor: pointer;
      background: #97999B;
      color: #FFF;
      padding: 6px 16px;
      border-radius: 4px !important;
      font-size: 14px;
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 5px;
    }
  }

  input {
    display: inline-block;
    width: 50%;
    height: 33px;
    padding: 0 10px;
  }

  button {
    display: inline-block;
    border: none;
    color: #FFF;
    height: 33px;
    padding: 0 20px;
    border-radius: 4px !important;
    cursor: pointer;
    font-size: 15px;
    width: auto;
    margin-right: 5px;
    margin-bottom: 20px;
    background: #3598DC;
  }

  span {
    font-size: 12px;
  }
}

.box-company-action {
  border-radius: 4px !important;

  h5 {
    color: #333;
    padding-bottom: 10px;
    border-bottom: 1px solid #BBBEC0;
    font-size: 21px;
    margin-bottom: 20px;
    margin-top: 0;
  }

  button {
    border: none;
    color: #FFF;
    padding: 8px 14px;
    border-radius: 4px !important;
    cursor: pointer;
    font-size: 15px;
    width: auto;
    margin-right: 5px;
    margin-bottom: 20px;

    i {
      margin-right: 5px;
    }
  }
}

.box-company-obs {
  .box-company-obs-content {
    position: relative;

    .input-file-group {
      position: relative;

      .remove-attack {
        font-size: 11px;
        color: var(--light-red);
        position: absolute;
        bottom: -20px;
        right: 0;
      }

      .ion-attach {
        position: absolute;
        right: 20px;
        top: 5px;
        font-size: 28px;
        visibility: visible !important;
      }

      .ion-error {
        cursor: pointer;
        color: #FF445D;
      }

      .ion-success {
        color: #2ACC6B;
      }

      .ion-loading {
        color: #191919;
        -webkit-animation: spin 3s linear infinite;
        -moz-animation: spin 3s linear infinite;
        animation: spin 3s linear infinite;
      }

      .input-file {
        width: 100%;
        background: #EEF2F7;
        border-radius: 4px !important;
        padding: 6px 12px;
        border: 1px solid #EEF2F7;
        transition: .2s;
        cursor: pointer;

        font-size: 16px;
        font-weight: 400;
        color: var(--dark-gray);

        &::placeholder {
          font-size: 16px;
          font-weight: 400;
          color: var(--dark-gray);
        }

        &:hover {
          transition: .2s;
          border: 1px solid #CACACA;
        }

        &:focus-visible {
          outline: none;
          transition: .2s;
          border: 1px solid #CACACA;

          &::placeholder {
            transition: .1s;
            color: #EEF2F7;
          }
        }

        &:focus {
          outline: none;
        }
      }
    }

    button {
      &:disabled {
        filter: grayscale(1);
        cursor: no-drop;

        &:hover {
          background: #3598DC;
        }
      }
    }

    .module-type {
      display: flex;
      justify-content: flex-end;
      position: absolute;
      right: 0;

      .tag-type {
        font-size: 17px;
        padding: 4px 19px;
        color: var(--classic-white);
        background: var(--high-blue);
        border-radius: 4px !important;
        cursor: default;
        margin-right: 15px;
      }

      .tag-point {
        background: #3598DC;
      }

      .tag-benefits {
        background: #265389;
      }

      .tag-beneflex-point {
        background: #4EB934;
      }

      .btn-trial {
        display: flex;
        align-items: center;

        font-size: 16px;
        border: 1px solid var(--dark-gray);
        color: var(--dark-gray);
        border-radius: 4px !important;
        padding: 3px 18px;

        cursor: default;

        a {
          text-decoration: none;
          height: 18px;
          margin-left: 10px;
          transition: .1s;

          ion-icon {
            font-size: 18px;
            color: var(--dark-gray);
            cursor: pointer;
            pointer-events: none;
          }

          &:hover {
            -moz-transform: scale(1.1);
            -webkit-transform: scale(1.1);
            transform: scale(1.5);
          }
        }
      }

      .btn-onboarding {
        display: flex;
        align-items: center;

        font-size: 17px;
        padding: 4px 19px;
        color: var(--dark-gray);
        background: var(--light-yellow);
        border-radius: 4px !important;

        cursor: default;

        a {
          text-decoration: none;
          height: 18px;
          margin-left: 10px;
          transition: .1s;

          ion-icon {
            font-size: 18px;
            color: var(--dark-gray);
            cursor: pointer;
            pointer-events: none;
          }

          &:hover {
            -moz-transform: scale(1.1);
            -webkit-transform: scale(1.1);
            transform: scale(1.5);
          }
        }
      }

      .btn-middle {
        display: flex;
        align-items: center;

        font-size: 17px;
        padding: 4px 19px;
        color: var(--classic-white);
        background: var(--high-blue);
        border-radius: 4px !important;

        cursor: default;

        a {
          text-decoration: none;
          height: 18px;
          margin-left: 10px;
          transition: .1s;

          ion-icon {
            font-size: 18px;
            color: var(--classic-white);
            cursor: pointer;
            pointer-events: none;
          }

          &:hover {
            -moz-transform: scale(1.1);
            -webkit-transform: scale(1.1);
            transform: scale(1.5);
          }
        }

      }

      .btn-white-label {
        display: flex;
        align-items: center;

        font-size: 17px;
        padding: 4px 19px;
        color: var(--classic-white);
        background: linear-gradient(114.27deg, #7E43AA 5.39%, #421F5B 98.22%);

        border-radius: 4px !important;

        cursor: default;

        a {
          text-decoration: none;
          height: 18px;
          margin-left: 10px;
          transition: .1s;

          ion-icon {
            font-size: 18px;
            color: var(--classic-white);
            cursor: pointer;
            pointer-events: none;
          }

          &:hover {
            -moz-transform: scale(1.1);
            -webkit-transform: scale(1.1);
            transform: scale(1.5);
          }
        }

      }

      .btn-ongoing {
        display: flex;
        align-items: center;

        font-size: 17px;
        padding: 4px 19px;
        color: var(--classic-white);
        background: var(--light-green);
        border-radius: 4px !important;

        cursor: default;

        a {
          text-decoration: none;
          height: 18px;
          margin-left: 10px;
          transition: .1s;

          ion-icon {
            font-size: 18px;
            color: var(--classic-white);
            cursor: pointer;
            pointer-events: none;
          }

          &:hover {
            -moz-transform: scale(1.1);
            -webkit-transform: scale(1.1);
            transform: scale(1.5);
          }
        }

      }
    }

    .owner-actual {
      position: absolute;
      right: 194px;
      top: 45px;
      max-width: 500px;

      font-size: 17px;
      padding: 4px 19px;
      color: #FFFFFF;
      background: #000000B0;
      border-radius: 4px !important;
    }

    .first-contact {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      position: absolute;
      right: 0;
      top: 45px;

      .signal-contact {
        font-size: 17px;
        padding: 4px 19px;
        color: var(--classic-white);
        background: #FF3707;
        border-radius: 4px !important;
        cursor: pointer;

        &:hover {
          background: #CE2800;
        }
      }

      .contact-msg {
        font-size: 12px;
        margin-top: 4px;
      }
    }
  }

  h5 {
    color: #333;
    padding-bottom: 10px;
    border-bottom: 1px solid #BBBEC0;
    font-size: 21px;
    margin-bottom: 20px;
    margin-top: 0;

    span {
      margin-right: 10px;
    }
  }

  select {
    margin-bottom: 40px;
    height: 30px;
    padding: 0 10px;
    border-radius: 4px !important;
  }

  textarea {
    min-width: 100%;
    max-width: 100%;
    height: 100px;
    border-radius: 4px !important;
    padding: 10px 10px;
  }

  .btn-send-obs {
    border-radius: 4px !important;
    background-color: #3598DC;
    height: 33px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    position: relative;
    top: 4px;
    width: auto;
    padding: 0 20px;
    margin-left: 0;
    margin-top: 10px;
    margin-bottom: 40px;

    &:hover {
      background-color: #054F91;
    }
  }

  .content-timeline {
    margin-left: 30px;

    .timeline-line {
      height: 100%;
      width: 5px;
      background: #A7AAAB;
      display: table-cell;
      position: relative;

      i {
        border-radius: 50px !important;
        color: #FFF;
        padding: 16px 14px;
        position: absolute;
        font-size: 22px;
        left: -23px;
        top: 20px;
      }

      img {
        border-radius: 50px !important;
        color: #FFF;
        position: absolute;
        left: -25.5px;
        top: 20px;
        background: #FFFFFF;
        border: 1px solid #A7AAAB;
        padding: 6px;
      }

      ion-icon {
        border-radius: 50px !important;
        transform: rotate(-30deg);
        color: #2F23D6;
        position: absolute;
        font-size: 40px;
        left: -25.5px;
        top: 20px;
        background: #FFFFFF;
        border: 1px solid #2F23D6;
        padding: 6px;
      }
    }

    .timeline-align {
      display: table-cell;
      width: 99.6%;

      .timeline-data {
        background: #E6E9EC;
        padding: 14px 15px;
        border-radius: 4px !important;
        margin-bottom: 30px;
        margin-left: 50px;
        max-width: 75%;
        min-width: 75%;
        position: relative;

        .remove {
          position: absolute;
          top: 6px;
          right: 14px;
          cursor: pointer;
          background: red;
          padding: 2px 6px;
          border-radius: 50px !important;
          color: #FFF;
          font-size: 11px;
        }

        .fixed {
          position: absolute;
          right: 45px;
          top: 6px;
          cursor: pointer;

          img {
            width: 18px;
            transition: all .2s;

            &:hover {
              transform: scale(1.2);
            }
          }
        }

        p {
          margin: 0 0 10px;
        }

        .obs {
          border-bottom: 1px solid rgba(255, 255, 255, 0.93);
          padding-bottom: 7px;
          margin-bottom: 10px;
          font-weight: 600;
          margin-top: 20px;
        }

        .have-height {
          max-height: max-content;
        }

        .text {
          max-height: 202px;
          overflow-y: hidden;

          .to-hide {
            background: none;
            bottom: 0;

            span {
              margin-top: 0;

              ion-icon {
                font-size: 18px;
              }
            }
          }

          span {
            word-break: break-word;
            font-weight: 600;
          }

          a {
            width: 100%;
            display: flex;
            justify-content: center;
            margin-left: -15px;
            position: absolute;
            bottom: 8px;
            background: #e6e9ec;

            span {
              margin-top: 20px;
            }
          }

          &-attachments {
            &-img {
              width: 120px;
              max-height: 55px;
              border-radius: 8px !important;
              object-fit: cover;

              span {
                width: 100%;
                height: 300px;
              }
            }

            &-pdf {
              display: flex;
              flex-direction: column;
              justify-content: center;
              text-align: center;
              position: relative;
              width: 117px;
              height: 117px;
              background: #EEF2F7;
              border-radius: 8px !important;

              span {
                font-size: 11px;
                font-weight: 700;
                color: #FFFFFF;
                background: #FF445D;
              }

              a {
                color: #2F23D6;
                font-size: 11px;
                font-weight: 600;
                margin-top: 4px;
              }
            }

            &-excel {
              display: flex;
              flex-direction: column;
              justify-content: center;
              text-align: center;
              position: relative;
              width: 117px;
              height: 117px;
              background: #EEF2F7;
              border-radius: 8px !important;

              span {
                font-size: 11px;
                font-weight: 700;
                color: #FFFFFF;
                background: #2ACC6B;
              }

              a {
                color: #2F23D6;
                font-size: 11px;
                font-weight: 600;
                margin-top: 4px;
              }
            }

            &-other {
              display: flex;
              flex-direction: column;
              justify-content: center;
              text-align: center;
              position: relative;
              width: 117px;
              height: 117px;
              background: #EEF2F7;
              border-radius: 8px !important;

              span {
                font-size: 11px;
                font-weight: 700;
                color: #FFFFFF;
                background: #FDD944;
              }

              a {
                color: #2F23D6;
                font-size: 11px;
                font-weight: 600;
                margin-top: 4px;
              }
            }
          }
        }

        .text-csat {
          display: flex;
          flex-direction: column;

          .csat-head {
            font-weight: 400;
            font-size: 12px;
            color: #3A424E;
          }

          .csat-content {
            font-size: 12px;
            color: #3A424E;

            span {
              font-weight: 400;
              font-size: 12px;
              color: #3A424E;
            }
          }
        }

        .user-note {
          font-weight: 600;

          .tag {
            color: #FFF;
            padding: 4px 12px 2.5px 12px;
            border-radius: 4px !important;
            display: inline-block;
            margin-left: 5px;
            font-size: 11px;
            font-weight: 400;

          }

          .email {
            background: #3598DC;
          }

          .jivo {
            background: #6C7C93;
          }

          .wts {
            background: #25D366;
          }

          .call {
            background: #17066D;
          }

          .nps {
            background: #283DA7;
          }

          .msg {
            background: #114A7F;
          }

          .warning {
            background: #F19D22;
          }

          .onbording {
            background: #0E600C;
          }

          .system {
            background: #898C8E;
          }

          .date {
            font-size: 11px;
            background: #BFC2C4;
            color: #333;
            padding: 4px 6px 4px;
            border-radius: 4px !important;
            font-weight: normal;
            position: relative;
          }

          .user-id {
            font-weight: normal;
            display: block;
            font-size: 10px;
            margin-top: 2px;
          }
        }
      }

      .payment-pending {
        background: #F8B873;
        font-size: 16px;
        color: #FFFFFF;

        .date {
          background: #FFFFFF !important;
        }
      }
    }
  }
}

.box-company-infos {
  h5 {
    color: #333;
    padding-bottom: 10px;
    border-bottom: 1px solid #BBBEC0;
    font-size: 21px;
    margin-bottom: 20px;
    margin-top: 0;
  }

  textarea {
    min-width: 100%;
    max-width: 100%;
    height: 100px;
  }

  .btn-save-info {
    border-radius: 4px !important;
    background-color: #3598DC;
    height: 33px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    position: relative;
    float: left;
    padding: 0 20px;
    margin-right: 5px;

    &:hover {
      background-color: #0682D7;
    }

    &:focus {
      box-shadow: 0 0 0 0.2rem #5EA0CD;
    }
  }

  .btn-edit-info {
    border-radius: 4px !important;
    background-color: #6C7C93;
    height: 33px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    position: relative;
    float: right;
    padding: 0 20px;

    &:hover {
      background-color: #556173;
    }

    &:focus {
      box-shadow: 0 0 0 0.2rem #B5BABE;
    }
  }

  .btn-edit-cancel {
    border-radius: 4px !important;
    background-color: #FF4105;
    height: 33px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    position: relative;
    float: left;
    padding: 0 20px;

    &:hover {
      background-color: #C42C05;
    }

    &:focus {
      box-shadow: 0 0 0 0.2rem #FF835C;
    }
  }

  .hidden {
  }

  .company-goals {
    display: flex;
    flex-direction: column;

    .goals-content {
      display: flex;
      flex-direction: column;
      margin-top: 10px;
      border-bottom: 1px solid #BBBEC0;
      padding-bottom: 10px;

      .content-group {
        display: flex;
        flex-direction: column;
      }
    }
  }
}

//tooltip
.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px !important;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/funnel/detailCompanyFunnel.vue